/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
/* eslint-disable max-len */
export const EN_US = {
    'test': 'test-test', // unit test do not delete
    'test_with_two_parameters': 'Test {{placeholder1}} test2 {{placeholder2}}', // unit test do not delete
    'color': 'color',

    '403_access_denied': 'Access denied',
    '404': '404: page missing',
    '404_page_not_found': 'Page Not Found',
    'Required': 'Required', // Has capital key for validation component
    'account_enter_current_password': 'Please enter your current password to continue.',
    'account_private_key_message': 'Your key is unique to you. Password recovery depends on its validation, and therefore requires that you download and store it in a safe place.',
    'accounts_download_key': 'Download key',
    'accounts_password_message': 'Leave fields blank if not changing the password',
    'accounts_recover_password': 'Reset password',
    'accounts_recover_password_complete_redirect_message': 'Go To Portal Sign In',
    'accounts_recover_password_email_label': 'Registered Email',
    'accounts_recover_password_intro': 'To reset your password, please enter your registered email and user private key.',
    'accounts_recover_password_intro_2': 'Now please enter your new password below.',
    'accounts_recover_password_redirect_login': 'Return to login page',
    'accounts_recover_password_upload_org_message': 'Select your organization private key',
    'accounts_recover_password_upload_user_message': 'Select your user private key',
    'accounts_recovery_download_key': 'Download Private Key',
    'accounts_recovery_download_key_org': 'Download Organization Key',
    'accounts_recovery_download_success_message': 'successfully downloaded',
    'accounts_recovery_keep_keys_safe': 'Please store your keys in a safe place!',
    'accounts_recovery_keep_keys_safe_message': 'If you forget your login details and need to reset your account, please make sure you download your keys.',
    'accounts_settings': 'Account settings',
    'accounts_settings_login_out_now': 'Log out now',
    'accounts_settings_phone_number_disabled': 'You can\'t change your phone number as SMS 2FA is enabled',
    'accounts_single-sign-on': 'Single Sign-on (SSO)',
    'accounts_sso_message': 'Select a SSO client to use for Portal log in',
    'accounts_sso_disabled_message': 'SSO is disabled as your organisation has SAML enforced.',
    'accounts_sso_upgrade_message': 'Enhance your organisation security by using SSO for your portal access.',
    'accounts_sso_upgrade_title': 'Upgrade to use SSO',
    'accounts_two_factor_auth': 'Two-Factor Authentication',
    'accounts_two_factor_auth_app': 'APP',
    'accounts_two_factor_auth_app_code_message': 'Alternatively, copy the code below and paste into your authenticator app.',
    'accounts_two_factor_auth_app_message': 'Use an app such as Google Authenticator to generate verification codes.',
    'accounts_two_factor_auth_app_title': 'Authenticator App',
    'accounts_two_factor_auth_app_using': 'Using App',
    'accounts_two_factor_auth_disable_app_message': 'Are you sure you want to disable authentication app verification?',
    'accounts_two_factor_auth_disable_sms_message': 'Are you sure you want to disable SMS verification?',
    'accounts_two_factor_auth_disable_tooltip': 'You can only use one 2FA verification method, to change to another method you need to turn off this one first.',
    'accounts_two_factor_auth_incorrect_code': 'The code does not match, please try again.',
    'accounts_two_factor_auth_message': 'Protect your account log in with 2-step verification.',
    'accounts_two_factor_auth_phone_message': 'Phone numbers can only contain numbers 0-9',
    'accounts_two_factor_auth_required': 'Two-factor Authentication Required',
    'accounts_two_factor_auth_resend': 'Resend Code',
    'accounts_two_factor_auth_sms': 'SMS',
    'accounts_two_factor_auth_sms_message': 'Use text messages to receive verification codes.',
    'accounts_two_factor_auth_sms_using': 'Using mobile',
    'accounts_two_factor_auth_upgrade_message': 'Enhance your organisation security by using Two-Factor-Authentication for your portal access.',
    'accounts_two_factor_auth_upgrade_title': 'Upgrade to use Two-Factor Authentication',
    'accounts_two_factor_auth_use_app': 'Scan the QR code from your authenticator app.',
    'accounts_two_factor_auth_use_app_code': 'Please enter the confirmation code that you see on your authentication app.',
    'accounts_two_factor_auth_use_sms': 'Use text messages (SMS) to receive verification codes.',
    'accounts_two_factor_auth_use_sms_code': 'Enter the 6-digit verification code we have sent to',
    'acl_delete': 'Delete ACL',
    'acl_delete_message': 'Are you sure you would like to delete this acl rule?',
    'acl_details_add_disabled_hint': 'Layer 4 ACL can only contain a single rule',
    'acl_details_return_to': 'Return to ACL details',
    'acl_edit': 'Edit ACL',
    'acl_select_layer': 'Select ACL layer',
    'acl_select_layer_message': 'Select the layer you wish to create the ACL for.',
    'acls_backend_mode_type': 'Backend is of mode type',
    'acls_frontend_mode_type': 'Frontend is of mode type',
    'acls_header_param': 'Header/Param',
    'acls_no_compatible_backends': 'There are no compatible backends. ',
    'acls_no_compatible_frontends': 'There are no compatible frontends. ',
    'acls_redirect_with_code': 'Redirect with code',
    'acls_type_layer4_warning': 'Layer 4 frontends can only have a single acl rule.',
    'acls_type_mismatch_message': 'Frontend and backend must be of same type e.g Layer 7',
    'acls_type_warning_message': 'This wizard is for Layer 7 ACLs only. To update an ACL rule for a layer 4 frontend, go to the ACL via the Manage ACLs page.',
    'activate_account_complete': 'Complete Account Activation',
    'activate_account_error': 'Activation Error',
    'activate_activation_passcode': 'Activation passcode',
    'activate_logging_in': 'Logging in',
    'activate_marketing_title': 'Confirm email address',
    'activate_portal_activated': 'Your Loadbalancer Portal has been activated!',
    'adc_add': 'Add ADC',
    'adc_add_address': 'ADC management details',
    'adc_add_api_details': 'API configuration details',
    'adc_add_instance': 'Add an ADC Instance',
    'adc_add_login_details': 'ADC Login details',
    'adc_add_message_a10': 'A10 Thunder load balancers facilitate efficient and reliable application delivery, in any environment. They deliver secure, visible and highly available applications for speed and agility.',
    'adc_add_message_citrix': 'Citrix NetScaler simplifies and automates application delivery and security across on-premise and cloud, delivering high-performing, resilient, and secure applications, no matter the application type and underlying infrastructure.',
    'adc_add_message_edgenexus': 'EdgeNexus ADCs deliver resilient and responsive services with granular control over application traffic, and secure, reliable, application delivery for always-on applications that are easy to deploy.',
    'adc_add_message_endurance': 'Loadbalancer Endurance is a next-generation load balancer, built for a cloud-native world. Currently in open beta, Endurance will become a fully commercial offering by the end of 2024.',
    'adc_add_message_enterprise': 'Loadbalancer Enterprise is designed to be clever, not complex, with flexible deployment and payment options. These fully featured ADCs deliver the highest throughput and unmatched reliability for critical workloads.',
    'adc_add_message_f5': 'F5 is a multi-cloud application services and security company, committed to bringing a better digital world to life. Although they have diversified their product range, their BIG-IP load balancer remains a core part of their offering.',
    'adc_add_message_generic': 'A generic device is a component in a networking setup, offering basic connectivity and data transmission capabilities. It typically includes features like routing, switching, and basic network security, serving as a versatile tool for establishing and managing network connections.',
    'adc_add_message_kemp': 'Progress Kemp LoadMaster ADCs are designed to optimize a wide array of applications with templates and support for web Application servers including SSL and HTTP/2, Microsoft applications and lots more.',
    'adc_add_message_shuttle_endurance': 'The upcoming version of our loadbalancing software',
    'adc_add_message_shuttle_enterprise': 'Powerful, highly customizable solution which includes automated configuration, content routing and caching, DSR, Layer 7 content switching, VLAN tagging, and many other features.',
    'adc_add_message_shuttle_stand_alone': 'A standalone shuttle is a lightweight sidecar proxy designed to seamlessly bridge your on-premise or cloud network to our SaaS platform. By securely routing traffic through the shuttle, your ADCs can connect to our services without complex configuration or direct exposure to the public internet, ensuring a streamlined and secure integration.',
    'adc_add_message_shuttle_token': 'Tokenized setup coming soon.',
    'adc_add_message_shuttle_virtual_machine': 'You are using one of our virtual machines to create a shuttle.',
    'adc_add_optional_info': 'Additional information (Optional)',
    'adc_add_ready_to_connect': 'Ready to connect',
    'adc_add_ready_to_connect_message': 'Please verify your settings. You can edit your details or hit the submit button below when ready. If the connection is successful, you’ll see your adopted appliance in your ADC list.',
    'adc_add_schedule': 'Add schedule',
    'adc_add_shuttle_details': 'Shuttle details',
    'adc_backup_now': 'Backup now',
    'adc_backups_view_list': 'View backups',
    'adc_data_no_notes': 'No notes added',
    'adc_data_no_tags': 'No tags added',
    'adc_direct_access': 'Direct access to ADC',
    'adc_direct_access_short': 'Direct access',
    'adc_download_success': 'Platform Downloaded Successfully',
    'adc_duplicate_ip_message': 'This IP address clashes with another ADC using this IP and port combination.',
    'adc_edit': 'Edit ADC',
    'adc_edit_details': 'Edit ADC details',
    'adc_edit_lock': 'Lock ADC',
    'adc_edit_lock_message': 'Lock your ADC from changes or removal.',
    'adc_empty_no_shuttle_message': 'The Portal uses Shuttle (Sidecar agent) to help manage your ADCs. In order to set up a new ADC please firstly add a Shuttle in ',
    'adc_empty_shuttle_message': 'You have ',
    'adc_empty_shuttle_message_2': 'Shuttles available, you can now use them to',
    'adc_empty_shuttle_message_3': 'add an ADC',
    'adc_empty_shuttle_message_4': 'to your network.',
    'adc_empty_shuttle_title': 'Ready to add your ADC.',
    'adc_empty_no_shuttle_title': 'No Shuttles in this namespace.',
    'adc_generic_message': 'Make sure you have access to this generic ADC.',
    'adc_go_to': 'Go To ADC',
    'adc_ha_status': 'HA status',
    'adc_ip_out_of_range': 'This IP address is out of range of the selected Shuttle.',
    'adc_locked': 'Locked',
    'adc_name': 'ADC Name',
    'adc_new_version': 'New version',
    'adc_no-warp_message': 'Remote access for this appliance is currently unavailable.',
    'adc_offline_message': 'This ADC is currently not online.',
    'adc_pending_adoption': 'Pending adoption',
    'adc_pending_adoption_message': 'This adc is attached to a shuttle that is pending adoption, do you want to link to the shuttle page?',
    'adc_port_clashes_with_another_ADC': 'This port clashes with another ADC using this port and IP combination.',
    'adc_remove': 'Remove ADC',
    'adc_remove_message': 'Are you sure you want to remove this ADC from your organization?',
    'adc_running_status': 'Running status',
    'adc_security_message': 'All good, nothing to review here.',
    'adc_security_message_not_supported': 'Security details for this vendor are not currently supported.',
    'adc_setup_appliance_message': 'Please go to your download and set it up for Loadbalancing.',
    'adc_setup_connected_message': 'Congratulations! Your ADC appliance has been set up and is ready for adoption. Go to the Loadbalancer Portal ADC List and hit the Adopt button.',
    'adc_setup_connected_title': 'Appliance ready for adoption',
    'adc_setup_help_prompt_message': 'Need help setting up your portal? Chat to one of our support team!',
    'adc_setup_shuttle': 'Setup Shuttle',
    'adc_setup_skip_to_overview': 'Skip to Overview',
    'adc_setup_successful_message': 'Shuttle set up successfully',
    'adc_shuttle_add': 'Add Shuttle',
    'adc_shuttle_adoption': 'Shuttle adoption',
    'adc_shuttle_associate': 'Associated ADC',
    'adc_shuttle_associated': 'Associated ADCs',
    'adc_shuttle_associated_none': 'No Associated ADCs',
    'adc_shuttle_button_message': 'Return to shuttles list',
    'adc_shuttle_confirm_adc': 'Confirm ADC credentials',
    'adc_shuttle_confirm_adc_message': 'It looks like you are trying to adopt a shuttle from a loadbalancer.org appliance. Please enter your ADC credentials so we can automatically add it for you.',
    'adc_shuttle_edit': 'Edit Shuttle',
    'adc_shuttle_edit_lock': 'Lock Shuttle',
    'adc_shuttle_edit_lock_message': 'Lock your Shuttle from changes or removal.',
    'adc_shuttle_edit_subnet_delete_message': 'Are you sure you want to delete this subnet?',
    'adc_shuttle_edit_subnet_existing_gateway': 'Use existing gateway',
    'adc_shuttle_edit_subnet_new_gateway': 'Create new gateway',
    'adc_shuttle_existing': 'Add existing Shuttle',
    'adc_shuttle_incoming_message': 'Please select the shuttle to adopt.',
    'adc_shuttle_incoming_message_2': 'NOTE: These might not be the shuttles you are looking for!',
    'adc_shuttle_incoming_message_3': 'Can\'t see your shuttle listed.',
    'adc_shuttle_intercom_message': 'I\'ve completed the steps on the \'Add shuttle\' page but I can\'t see my shuttle.',
    'adc_shuttle_management': 'Shuttle Management',
    'adc_shuttle_name': 'Shuttle Name',
    'adc_shuttle_new': 'Add new Shuttle',
    'adc_shuttle_new_message': 'A shuttle is a sidecar agent that creates a communication channel between the Portal and the ADCs available on your network.',
    'adc_shuttle_new_message_2': 'In order to add and manage an ADC in Portal, you will need to add a Shuttle first.',
    'adc_shuttle_new_title': 'What is a Shuttle?',
    'adc_shuttle_no_associated_adcs': 'There are no ADCs associated with this shuttle.',
    'adc_shuttle_remove': 'Remove Shuttle',
    'adc_shuttle_remove_message': 'Are you sure you want to remove this shuttle from your organization?',
    'adc_shuttle_skip-adoption': 'Skip ADC adoption',
    'adc_shuttle_token_linux': 'Linux environment',
    'adc_shuttle_token_linux_message': 'The Shuttle shell script works under Linux, simply copy the token into your terminal and run it. It will automatically install all the resources required.',
    'adc_shuttle_token_message': 'Copy the following token and run it in your loadbalancer\'s shell environment:',
    'adc_shuttle_token_message_standalone': 'Copy the following token and run it in your shell environment:',
    'adc_shuttle_token_requirements': 'Requirements',
    'adc_shuttle_token_requirements_message': 'Please make sure the following is installed in your environment:',
    'adc_shuttle_update': 'Update Shuttle',
    'adc_shuttle_waiting': 'Waiting for shuttle',
    'adc_this_cant_message': 'This action can\'t be completely at this time or you don\'t have permission',
    'adc_update_disabled': 'This ADC doesn\'t support updates via portal.',
    'adc_update_error': 'Error updating this ADC. Please contact support or try again in a few minutes.',
    'adc_update_now': 'Update now',
    'adc_view_schedules': 'View schedules',
    'adc_view_security_risks': 'View security risks',
    'adc_waiting_for_shuttle': 'Waiting for shuttle setup...',
    'adc_warp_to_adc': 'Warp to ADC',
    'adc_warp_vendor_not_included': 'Warp is not currently available for this vendor',
    'adc_widget_connections': 'ADC connections used',
    'admin_panel': 'Portal Admin',
    'advanced_services': 'Advanced services',
    'advanced_services_advanced_stats': 'Advanced stats',
    'advanced_services_buffer_size': 'Buffer size',
    'advanced_services_client_timeout': 'Client timeout',
    'advanced_services_conn_timeout': 'Connection timeout',
    'advanced_services_email_alert_from': 'Email alert from',
    'advanced_services_email_alert_to': 'Email alert to',
    'advanced_services_email_alerts': 'Email alerts',
    'advanced_services_email_server_addr': 'Email server address',
    'advanced_services_email_server_port': 'Email server port',
    'advanced_services_enable_multi_thread': 'Enable multi threading',
    'advanced_services_enable_ssl': 'Enable SSL',
    'advanced_services_enable_stats': 'Enable stats page',
    'advanced_services_haproxy_stats_advanced': 'HaproxyStatsAdvanced',
    'advanced_services_hdr_buf_len': 'Header buffer length',
    'advanced_services_logging': 'Logging',
    'advanced_services_multi_thread': 'Multi threading',
    'advanced_services_no_of_threads': 'Number of threads',
    'advanced_services_persist_repl_port': 'Persistence replication port',
    'advanced_services_persist_replication': 'Enable persistence replication',
    'advanced_services_persistence_table': 'Persistence table replication',
    'advanced_services_real_server_timeout': 'Real server response timeout',
    'advanced_services_req_buf_len': 'Request buffer length',
    'advanced_services_ssl_cache_options': 'SSL cache options',
    'advanced_services_ssl_cache_size': 'SSL cache size',
    'advanced_services_statistics_page': 'Statistics page',
    'app_overlay_message': 'works best on a larger screen',
    'auditing': 'Auditing',
    'auditing_activity_type': 'Activity type',
    'auditing_session_log': 'Session log',
    'auditing_session_time': 'Session time',
    'auditing_upgrade_message': 'Enhance your organisation security by using Auditing for your portal access.',
    'auditing_upgrade_title': 'Upgrade to use Auditing',
    'backup_download_message': 'Please enter your password in order to decrypt this backup.',
    'backup_for': 'Backup for',
    'backup_restore': 'Backup & restore',
    'backup_restore_auto_backup': 'Auto backup',
    'backup_restore_download_complete': 'Backup download complete',
    'backup_restore_make_fip_active': 'Make active',
    'backup_restore_node_name': 'Node name',
    'backup_restore_restore_from': 'Restore From Backup',
    'backup_restore_restore_model_text': 'The box is being restored. You will be logged out and reload in',
    'backup_restore_select_node_message': 'Please select to restore from a node or part restore.',
    'backup_restore_select_section_message': 'You can select individual item(s) to restore from',
    'backup_restore_select_type': 'Restore Type',
    'backup_restore_upload_backup': 'Upload backup',
    'backup_restore_uploaded_backups': 'Uploaded backups',
    'backup_widget_backups_used': 'backups used',
    'billing_adc_pack': 'Extras',
    'billing_portal': 'Tiers',
    'billing_add_payment_method': 'Add new payment method',
    'billing_address': 'Billing address',
    'billing_amount': 'Amount',
    'billing_bad_debt': 'Bad debt',
    'billing_cancel_plan': 'Cancel plan',
    'billing_card_cvc': 'CVC',
    'billing_card_details': 'Card details',
    'billing_card_ending': 'card ending...',
    'billing_card_name': 'Name on card',
    'billing_card_number': 'Card number',
    'billing_card_selected': 'Selected card',
    'billing_contact': 'Contact billing',
    'billing_date': 'Billing date',
    'billing_draft': 'Draft',
    'billing_edit_payment_method': 'Edit payment method',
    'billing_email_address': 'Billing email address',
    'billing_edit_subscription': 'Edit subscription',
    'billing_expiry': 'Expiry',
    'billing_invoice': 'Invoice',
    'billing_invoice_history': 'Invoice history',
    'billing_item': 'Item',
    'billing_items': 'Billing items',
    'billing_make_default': 'Make default',
    'billing_monthly_cost': 'Monthly cost',
    'billing_name': 'Billing name',
    'billing_paid': 'Paid',
    'billing_payment_method': 'Payment method',
    'billing_payment_methods': 'Payment methods',
    'billing_payment_status': 'Payment submission status',
    'billing_remove_payment': 'Remove Payment Method',
    'billing_remove_payment_message': 'Are you sure you want to remove this payment method?',
    'billing_remove_subscription': 'Cancel subscription',
    'billing_remove_subscription_hint': 'Subscription already cancelled',
    'billing_remove_subscription_message': 'Are you sure you want to cancel this subscription?',
    'billing_waiting_payment': 'Waiting for payment',
    'certificate_add_ca': 'Add CA',
    'certificate_add_certificate': 'Add Certificate',
    'certificate_add_crl': 'Add CRL',
    'certificate_apply_csr': 'Apply CSR',
    'certificate_common_name': 'Common Name',
    'certificate_country': 'Country',
    'certificate_country_code': 'Country code',
    'certificate_create_cert': 'Create certificate',
    'certificate_create_csr': 'Create CSR',
    'certificate_create_self-signed': 'Create self-signed',
    'certificate_csr': 'Certificate request',
    'certificate_csrs_subject_alt': 'Subject Alt(s)',
    'certificate_counter_label_total': 'Total Certificates',
    'certificate_counter_label_expiring': 'Expiring (30 days)',
    'certificate_counter_label_expired': 'Expired Certificates',
    'certificate_counter_none': 'No certificates available.',
    'certificate_counter_none_message': 'All security certificates associated with your ADCs will be displayed here.',
    'certificate_details': 'Certificate details',
    'certificate_domain_cn': 'Domain (CN)',
    'certificate_edit_ca': 'Edit CA',
    'certificate_edit_cert': 'Edit Cert',
    'certificate_edit_certificate': 'Edit Certificate',
    'certificate_edit_crl': 'Edit CRL',
    'certificate_edit_csr': 'Edit CSR',
    'certificate_expired_today': 'Expired today',
    'certificate_expired_x_days_ago': 'Expired {{placeholder}} days ago',
    'certificate_expires_x_days': 'Expires in {{placeholder}} days',
    'certificate_input_subject_alt': 'subjectAlt',
    'certificate_inter_certs': 'Intermediate certificate',
    'certificate_invalid_email': 'Invalid email',
    'certificate_issuer': 'Issuer',
    'certificate_key_length': 'CSR key length',
    'certificate_locality': 'Locality (L)',
    'certificate_name': 'Certificate Name',
    'certificate_organization': 'Organization (O)',
    'certificate_organizational_unit': 'Organization unit (OU)',
    'certificate_private_key': 'Private key',
    'certificate_root_cert': 'Root certificate',
    'certificate_san_label': 'Subject Alt Name/s (SAN)',
    'certificate_select_cert': 'Select certificate',
    'certificate_self_signed': 'Self signed',
    'certificate_signature_algorithm': 'Signature algorithm',
    'certificate_state_st': 'State or province (ST)',
    'certificate_subject_alt': 'Subject alt (SAN)',
    'certificate_view_csr': 'View CSR',
    'checkout_cart': 'Cart',
    'checkout_cart_add_hint_test': 'You can\'t have more than one tier subscription',
    'checkout_cart_empty_message': 'Your cart is empty',
    'checkout_cart_max-items_message': 'You have reached the maximum number of items in the cart.',
    'checkout_interval_hint_test': 'You can\'t mix types of subscription',
    'checkout_select_payment_card': 'Select payment method',
    'checkout_select_product': 'Select product',
    'checkout_selected_payment_card': 'Selected payment method',
    'checkout_selected_product': 'Selected product',
    'cipher_list_available': 'Ciphers available',
    'cipher_list_create_new': 'Add new cipher',
    'cipher_list_delete_cipher': 'Delete cipher',
    'cipher_list_edit_cipher': 'Edit cipher',
    'cipher_list_name': 'List name',
    'cipher_list_new': 'New cipher list',
    'cipher_list_selected': 'Ciphers selected',
    'cipher_list_title': 'SSL Cipher Lists',
    'cipher_list_tls_version': 'TLS version',
    'cipher_list_view': 'View cipher list',
    'confirm_logout': 'Are you sure you would like to logout?',
    'create_bond_available_interfaces': 'Available interfaces',
    'create_bond_bond_name': 'Bond name',
    'create_bond_eth_brackets': '(eth)',
    'create_bond_help_text': 'Click two or more interfaces to bond',
    'create_bond_no_interfaces_found': 'No interfaces found.',
    'create_bond_please_return_to': 'Please return to',
    'csv_importer_title': 'Assign columns to fields',
    'csv_importer_description': 'In this modal, you need to map the CSV headings to the corresponding submission fields. All required fields must be matched before you can submit. Once submitted successfully, each user will receive an email with an activation link. They will then be prompted to enter their name and create a password. After setting their password, users must download a copy of their private userKey and store it in a safe place in case of an account recovery.',
    'csv_importer_missing_fields': 'Missing required fields:',
    'csv_importer_missing_fields_set': 'Number of required fields set:',
    'csv_importer_heading_csv_headings': 'CSV Headings',
    'csv_importer_heading_submission_headings': 'Submission fields',
    'csv_importer_number_records': 'Number of records: ',
    'csv_importer_preview': 'Preview',
    'csv_importer_import_users': 'Import users',
    'csv_importer_switch_view_errors': 'View errors',
    'csv_importer_switch_view_results': 'View results',
    'dashboard_advert_boost_title': 'Boost your ADC experience with new features',
    'dashboard_advert_demo_title': 'Need help? Schedule a free demo with a Portal engineer',
    'dashboard_advert_trial_title': 'Try our fully-featured load balancer free for 30 days',
    'dashboard_features': 'Features',
    'dashboard_guides': 'Guides',
    'dashboard_quick_links': 'Quick links',
    'dashboard_whats_new': 'Portal: What\'s new',
    'date_time_current_sys_time': 'Current system time',
    'date_time_date_out_of_range_license_text': 'Warning: your date is outside your current license period. By changing your date you will invalidate your license. Are you sure you wish to proceed?',
    'date_time_date_out_of_range_license_title': 'License warning',
    'date_time_date_out_of_range_relogin_text': 'Warning: your date & time is set to a time in the future. You may be prompted to re-login.',
    'date_time_date_out_of_range_relogin_title': 'Date warning',
    'date_time_ntp_server_1': 'ntp server 1',
    'date_time_ntp_server_2': 'ntp server 2',
    'date_time_ntp_server_3': 'ntp server 3',
    'date_time_ntp_servers': 'NTP servers',
    'date_time_set_date_time': 'Set date & time',
    'date_time_set_manually': 'Set date and time manually',
    'date_time_set_ntp': 'Set NTP',
    'date_time_set_timezone': 'Set timezone',
    'date_time_sys_timezone': 'System timezone',
    'date_time_use_ntp_servers': 'Use NTP servers',
    'error_page_title': 'This page is currently unavailable',
    'error_page_message': 'We are working on a fix for you.',
    'execute_command_common': 'Common Commands',
    'execute_command_input': 'Command Input',
    'execute_shell_command': 'Execute shell command',
    'external_all_rights_reserved': 'All rights reserved',
    'external_link': 'External link',
    'fallback_add': 'Add fallback server',
    'fallback_masq': 'MASQ Fallback',
    'fallback_page_edit': 'Edit fallback page',
    'fallback_pages': 'Fallback pages',
    'fallback_pages_add_page': 'Add fallback page',
    'fallback_pages_delete_page': 'Delete page',
    'fallback_pages_delete_page_message': 'Are you sure that you wish to delete the fallback page?',
    'fallback_pages_page_content': 'Page content',
    'fallback_pages_usage': 'Fallback page usage',
    'fallback_server': 'Fallback server',
    'floating_ip': 'Floating IP',
    'floating_ip_add': 'Add floating IP',
    'floating_ip_all_disable': 'Disable all floating IPs',
    'floating_ip_all_enable': 'Enable all floating IPs',
    'floating_ip_change': 'IP Changed',
    'floating_ip_change_message': 'The IP you are changing is assign to a service and that service will need to be reloaded',
    'floating_ip_delete_message': 'All selected floating IPs, not in use have been deleted',
    'floating_ip_delete_multiple_ips': 'Delete multiple IPs',
    'floating_ip_delete_selected': 'Delete selected floating IPs',
    'floating_ip_deleting_multiple_ip': 'Deleting IP',
    'floating_ip_disable': 'Disable floating IP',
    'floating_ip_disable_selected': 'Disable selected floating IPs',
    'floating_ip_edit': 'Edit floating IP',
    'floating_ip_enable': 'Enable floating IP',
    'floating_ip_enable_selected': 'Enable selected floating IPs',
    'floating_ip_in_use': 'In use',
    'floating_ip_usage': 'Floating IP usage',
    'floating_ip_usage_for_ip': 'Usage for IP',
    'free_trial_step_1_button': 'Get started',
    'free_trial_step_1_intro': 'Your trial is a fully unrestricted version of our Enterprise VA Max and is free to use for 30 days. Should you require an extension of the trial please contact us.',
    'free_trial_step_1_simple_steps': 'Simple steps:',
    'free_trial_step_1_step_message_1': 'Choose your hypervisor and download.',
    'free_trial_step_1_step_message_2': 'If you need help during your free ADC trial, you get full access to our 24/7 support',
    'free_trial_step_1_step_message_3': 'Register for the ADC Portal free trial - our new centralized management system',
    'free_trial_step_1_title': 'Let’s get your Enterprise ADC free trial started.',
    'free_trial_step_2_intro': 'Select your preferred hypervisor from the list below. Our load balancer can run on a range of other hypervisors, If yours isn’t in the list, contact us and we’ll help you out.',
    'free_trial_step_2_min_spec': '64bit CPU, Virtual Technology hardware support (either Intel-VT-x or AMD-V compliant CPUs). By default, the virtual appliance is allocated 2 vCPUs, 4GB of RAM and has a 20GB virtual disk, which should be suitable for low to medium throughput production applications. (They can be increased as needed)',
    'free_trial_step_2_title': 'Choose your hypervisor.',
    'free_trial_step_3_button': 'Take a peek at Portal',
    'free_trial_step_3_intro': 'Thank you for downloading your free Enterprise ADC trial. You are now ready to set up the appliance on your virtual machine.',
    'free_trial_step_3_intro_2': 'The Quick start guide (included in your download) will take you through the set up steps but should you require further assistance please contact us.',
    'free_trial_step_3_intro_3': 'Other users are finding it beneficial to utilize our new ADC Portal — we’ve already created you an account, simply activate it to start exploring it for free.',
    'free_trial_step_3_quick_start': 'Quick start guide',
    'free_trial_step_3_title': 'Thank you.',
    'free_trial_step_3_title_2': 'Try the new Loadbalancer ADC Portal',
    'free_trial_step_4_button_action_later': 'I’ll do this later',
    'free_trial_step_4_button_activate_trial': 'Activate my free Portal trial',
    'free_trial_step_4_intro': 'The Loadbalancer ADC Portal is an intuitive, yet comprehensive platform that enables automation, orchestration, management, and analytics for application delivery across on-prem, cloud, hybrid and multi-cloud environments.',
    'free_trial_step_4_step_message_1': 'Consolidate all your appliances in a single dashboard.',
    'free_trial_step_4_step_message_2': 'Create automated workflows to allow common ADC tasks.',
    'free_trial_step_4_step_message_3': 'Full end-to-end security, using state-of-the-art cryptographic technology.',
    'free_trial_step_4_title': 'Loadbalancer ADC Portal',
    'free_trial_step_5_button_schedule_demo': 'Schedule demo',
    'free_trial_step_5_button_skip': 'Skip & finish',
    'free_trial_step_5_intro': 'Need help setting up your ADC appliance, why not schedule a demo or support call with one of our engineers. You can book a meeting at a date and time that suits you by clicking on the button below.',
    'free_trial_step_5_intro_2': 'Alternatively, 24/7 support is included for the duration of your free trial and our team can be reached by email ',
    'free_trial_step_5_intro_3': 'via online chat or by completing a support ticket - ',
    'free_trial_step_5_title': 'Need some help. Why not schedule a demo?',
    'gslb_add_global_name': 'Add global name',
    'gslb_add_global_names': 'Add global names',
    'gslb_add_member': 'Add member',
    'gslb_add_pool': 'Add pool',
    'gslb_add_topology': 'Add topology',
    'gslb_available_members': 'Available members',
    'gslb_delete_global_name': 'Delete global name',
    'gslb_delete_member': 'Delete Member',
    'gslb_delete_pool': 'Delete pool',
    'gslb_delete_topology': 'Delete topology',
    'gslb_edit_global_name': 'Edit global name',
    'gslb_edit_member': 'Edit member',
    'gslb_edit_pool': 'Edit pool',
    'gslb_edit_topology': 'Edit Topology',
    'gslb_global_name': 'Global name',
    'gslb_global_names': 'Global names',
    'gslb_global_services': 'Global service',
    'gslb_healthcheck_expected_codes': 'Healthcheck expected codes',
    'gslb_healthcheck_hostname': 'Healthcheck hostname',
    'gslb_healthcheck_interval': 'Healthcheck interval',
    'gslb_healthcheck_ip': 'Healthcheck IP',
    'gslb_healthcheck_match_re': 'Healthcheck match RE',
    'gslb_healthcheck_mode': 'Healthcheck mode',
    'gslb_healthcheck_no_scripts_found': 'No health check scripts found',
    'gslb_healthcheck_port': 'Healthcheck port',
    'gslb_healthcheck_retries': 'Healthcheck retries',
    'gslb_healthcheck_script': 'Healthcheck script',
    'gslb_healthcheck_send_string': 'Healthcheck send string',
    'gslb_healthcheck_status': 'Healthcheck status',
    'gslb_healthcheck_timeout': 'Healthcheck timeout',
    'gslb_healthcheck_type': 'Healthcheck type',
    'gslb_healthcheck_url_path': 'Healthcheck URL path',
    'gslb_healthcheck_use_ssl': 'Healthcheck use SSL',
    'gslb_ip_subnet': 'IP subnet',
    'gslb_lb_method': 'LB method',
    'gslb_max_address_returned': 'Max address returned',
    'gslb_no_available_global_names': 'No available global names',
    'gslb_no_data_gslb_pools': 'No data is currently being collected for GSLB pools.',
    'gslb_no_members': 'No members',
    'gslb_no_members_text': 'You have no members set up. Members are required in order to create a topology.',
    'gslb_pools_input_monitorCode': 'Monitor code',
    'gslb_refuse_on_failure': 'Refuse on failure',
    'gslb_report_distribution': 'GSLB distribution state report',
    'gslb_report_distribution_error': 'GSLB distribution state data is unavailable',
    'gslb_report_health_check': 'GSLB health check report',
    'gslb_report_health_check_error': 'GSLB health check data is unavailable',
    'gslb_return_to_gslb_page': 'Return to GSLB page',
    'gslb_selected_members': 'Selected members',
    'gslb_time_to_live': 'Time to live',
    'ha_conf': 'High availability configuration',
    'ha_conf_add_node': 'Add node',
    'ha_conf_administrator_email': 'Administrator email*',
    'ha_conf_administrator_password': 'Administrator password*',
    'ha_conf_bind_address': 'Bind address',
    'ha_conf_confirm_service_restart': 'Confirm service restart',
    'ha_conf_confirm_service_restart_message': 'You are restarting a service on a different node to the one you are currently logged into.',
    'ha_conf_join': 'High availability join',
    'ha_conf_join_confirmation': 'High availability add confirmation',
    'ha_conf_join_confirmation_message': 'Please confirm that you would like to continue adding the node as this process will erase your peers configuration.',
    'ha_conf_last_health_check': 'Last health check',
    'ha_conf_latency': 'Latency',
    'ha_conf_peer_ip_address': 'Peer IP address*',
    'ha_conf_peer_port': 'Peer port*',
    'ha_conf_promote': 'Promote',
    'ha_conf_re_sync_config': 'Re-sync config',
    'ha_conf_reload_restart_services': 'Reload/Restart services',
    'ha_conf_remove_node_title': 'Remove node',
    'ha_conf_remove_node_message': 'Are you sure that you want to delete this node?',
    'ha_conf_restore_confirmation': 'Confirm node restore',
    'ha_conf_restore_confirmation_message': 'Please confirm that you would like to restore the node.',
    'ha_conf_restore_node': 'Restore node',
    'ha_conf_services_message': 'Some services need restarting before you can add a node. Make sure the other node is up to date and the required services are running.',
    'ha_conf_services_unavailable': 'Services unavailable',
    'hanging_acl_delete': 'Delete ACL',
    'hanging_acl_deleted_all': 'All hanging ACLs deleted',
    'hanging_acl_deleting': 'Deleting hanging ACL',
    'hanging_acls': 'Hanging ACLs',
    'hanging_acls_acls_list': 'Below is a list of ACLs that are not associated to a frontend.',
    'hanging_acls_deleted_all': 'All hanging ACLs deleted',
    'hanging_acls_deleting': 'Deleting hanging ACLs',
    'hanging_backend_delete': 'Delete Backend',
    'hanging_backend_delete_message': 'Are you sure that you want to delete backend',
    'hanging_backend_delete_message_multiple': 'Are you sure that you want to delete the selected hanging backends?',
    'hanging_backend_delete_selected': 'Delete selected hanging backends',
    'hanging_backend_deleted_all': 'All hanging backends deleted',
    'hanging_backend_deleting': 'Deleting hanging backend',
    'hanging_backend_real_servers_usage': 'Real servers usage',
    'hanging_backends': 'Hanging backends',
    'hanging_backends_backends_info': 'You can create rules to assign them or delete them',
    'hanging_backends_backends_list': 'Below is a list of backends that are not associated to a frontend.',
    'hanging_backends_create_acl': 'Create ACL',
    'hanging_backends_deleting': 'Deleting hanging backends',
    'hanging_backends_usage_for_backend': 'Real servers usage for hanging backend',
    'hanging_backends_usage_real_server_address': 'Real servers address',
    'hanging_backends_usage_real_server_label': 'Real servers label',
    'hanging_groups_assign': 'Assign hanging groups',
    'hanging_groups_remote_node': 'This assignment is on a remote node',
    'hanging_real_assign': 'Assign real servers',
    'hanging_real_assign_backend': 'Assign to a backend',
    'hanging_real_assign_backend_count': 'Available backends',
    'hanging_real_assign_confirm_message_multiple': 'Are you sure you want to assign the selected real servers to the selected backends?',
    'hanging_real_assign_confirm_message_single': 'Are you sure that you want to assign real server',
    'hanging_real_assign_no_backend_message': 'No matching backends',
    'hanging_real_assigned_all': 'All selected hanging real servers assigned',
    'hanging_real_delete': 'Delete real server',
    'hanging_real_delete_all': 'Delete selected real servers',
    'hanging_real_delete_confirm_message_multiple': 'Are you sure that you want to delete the selected hanging real servers?',
    'hanging_real_delete_confirm_message_single': 'Are you sure that you want to delete real server ',
    'hanging_real_deleting': 'Deleting hanging real server',
    'hanging_reals': 'Hanging real servers',
    'hanging_reals_deleted_all': 'All hanging real servers deleted',
    'hanging_reals_deleting': 'Deleting hanging real servers',
    'hanging_reals_real_servers_usage': 'Real servers usage',
    'hanging_reals_reals_list': 'Below is a list of real servers that are not associated to a service.',
    'hanging_reals_usage_real_server_address': 'Real servers address',
    'hanging_reals_usage_real_server_label': 'Real servers label',
    'header_add_header': 'Add header',
    'header_edit_header': 'Edit header',
    'header_replace_value': 'Replace value',
    'health_check': 'Health Check',
    'health_check_add': 'Add health check',
    'health_check_confirm_delete_text': 'Are you sure you would like to delete this health check?',
    'health_check_created_by': 'Created by',
    'health_check_script_content': 'Script content',
    'health_checks': 'Health checks',
    'health_checks_radius_secret': 'Radius Secret',
    'health_checks_usage': 'Health check usage',
    'host_dns': 'Hostname & DNS',
    'host_dns_domain_name_servers': 'Domain name servers',
    'ip_add_group': 'Add IP Group',
    'ip_delete_group_text': 'Are you sure you would like to delete this group?',
    'ip_edit_group': 'Edit IP Group',
    'ip_enable_fip': 'Enable floating IP',
    'ip_enable_ipv4': 'Enable IPv4',
    'ip_enable_ipv6': 'Enable IPv6',
    'ip_go_to_groups': 'Go to floating IP groups',
    'ip_group_no_mask_set': 'No mask set',
    'ip_groups': 'IP groups',
    'ip_groups_disconnection_warning': ' Please make sure this is correct otherwise you will lose connection to your loadbalancer.',
    'ip_groups_gateway_changed': 'Default gateway change',
    'ip_groups_gateway_changed_text': 'Default gateway has been changed to the new IP Group ',
    // TODO: Remove when IP groups is renamed globally.
    'ip_groups_subnets': 'IP groups (Subnets)',
    // TODO: END
    'ip_groups_unassigned_group': 'Unassigned group',
    'ip_groups_usage': 'IP Groups usage',
    'ip_hanging_groups': 'Hanging groups',
    'ip_ipv4_mask': 'IPv4 mask',
    'ip_ipv4_mask_upper': 'IPv4 Mask',
    'ip_ipv4_network': 'IPv4 network',
    'ip_ipv4_network_upper': 'IPv4 Network',
    'ip_ipv6_mask': 'IPv6 mask',
    'ip_ipv6_mask_upper': 'IPv6 Mask',
    'ip_ipv6_network': 'IPv6 network',
    'ip_ipv6_network_upper': 'IPv6 Network',
    'ip_name_change': 'Group name changed',
    'ip_name_change_text': 'The group name has changed. This will take down and then bring up any IP in this group. Do you wish to proceed?',
    'ip_no_ip_config': 'You currently do not have any IP groups configured. In order to create a new floating IP, please first create a new IP group before trying again.',
    'ip_no_network_set': 'No network set',
    'l7_stick_table': 'Layer 7 stick table',
    'l7_stick_table_refresh': 'Refresh stick table',
    'l7_stick_table_select_backend': 'Select backend:',
    'licence_contact_support': 'Please contact support@loadbalancer.org.',
    'licence_expiration_due': 'Your support is due to expire in ',
    'licence_expired_guide': 'Please enter your new license key or if you do not have a valid license key please contact us.',
    'licence_model': 'Model',
    'licence_question': 'Have a Licensing Question?',
    'licence_question_description': 'We have loads of licensing options to suit your business needs, chat to one of our friendly sales bunnies today!',
    'licence_serial_number': 'Serial number',
    'licence_support_ends_on': 'Support Ends On',
    'licence_support_expires_in': 'Support expires in ',
    'licence_type': 'License type',
    'licence_update_key': 'Update license key',
    'licence_widget_core_updates': 'Core updates',
    'licence_widget_details': 'License details',
    'licence_widget_expiry': 'License expiry',
    'licence_widget_lifetime': '(Lifetime)',
    'licence_widget_security_updates': 'Security updates',
    'licenced': 'Licensed',
    'license_expired': 'Your license has expired',
    'license_update_license_guide': 'To activate your complimentary Premium Technical Support please enter a valid license key. To obtain your license key please contact us.',
    'license_warn_remaining_days': 'The support contract for this appliance will expire in ',
    'license_warn_support_expired': 'The support contract has expired on this appliance. ',
    'loadbalancer_cluster_configuration': 'Cluster configuration',
    'loadbalancer_local_config': 'Local configuration',
    'loadbalancer_network': 'Network',
    'loadbalancer_website_link': 'You are about to be taken to the Loadbalancer website',
    'login': 'Login',
    'login_connection_settings': 'Connection settings',
    'login_error': 'Login error',
    'login_host_ip': 'Host IP',
    'login_invalid_ip': 'Invalid IP',
    'login_reset_it': 'Reset it',
    'login_reset_password_message': 'Enter your registered email below to receive instructions on how to reset your password.',
    'login_untrusted_host_certificate': 'Untrusted host certificate',
    'login_zero_downtime': 'Zero Downtime.',
    'logout_confirmation': 'Logout confirmation',
    'logout_warning_title': 'Logout warning',
    'logout_warning_message': 'You will be logged out in: ',
    'logs_clear_services': 'Clear services',
    'logs_comm': 'Comm',
    'logs_date_time_format': 'Date Time (yyyy-mm-dd)',
    'logs_error_data': 'Error retrieving data from the API, please contact support.',
    'logs_fetching_data': 'Fetching data...',
    'logs_log_config': 'Log configuration',
    'logs_message': 'Message',
    'logs_no_more': 'No more logs to show.',
    'logs_pid': 'PID',
    'logs_reverse': 'Reverse',
    'logs_start': 'Start logs',
    'logs_uid': 'UID',
    'manage_acl_rules': 'Manage ACL rules',
    'manage_acls': 'Manage ACLs',
    'manage_acls_add': 'Add ACL',
    'manage_acls_no_frontends_or_backends': 'No frontends or backends found',
    'manage_acls_no_frontends_or_backends_text': 'You currently do not have any frontends or backends, click on confirm to be navigated to manage services page, where you can create a new service.',
    'manage_acls_path_type': 'Path type',
    'manage_acls_redirect_location': 'Redirect location',
    'manage_acls_redirect_type': 'Redirect type',
    'manage_acls_return_to': 'Return to Manage ACLs',
    'manage_services': 'Manage services',
    'manage_services_add_layer_4': 'Add Layer 4 Service',
    'manage_services_add_layer_7': 'Add Layer 7 Service',
    'manage_services_add_monitor': 'Add Monitor',
    'manage_services_delete_selected': 'Delete selected frontends',
    'manage_services_delete_multiple_frontends': 'Delete multiple Frontends?',
    'manage_services_deleting': 'Deleting frontends',
    'manage_services_duplicate_monitor': 'Duplicate Monitor',
    'manage_services_edit_layer_4': 'Edit Layer 4 Service',
    'manage_services_edit_layer_7': 'Edit Layer 7 Service',
    'manage_services_edit_monitor': 'Edit Monitor',
    'manage_services_return': 'Return to Manage services',
    'manage_services_view_stick_table': 'View stick table',
    'missing_ip_add_to_complete': 'The following ip address(es) need to be created in order to complete this wizard.',
    'missing_ip_addresses': 'FIP setup',
    'missing_ip_status': 'FIP status',
    'missing_ip_submit_new_ips': 'Submit new IPs',
    'mtls_ca': 'Certificate Authority',
    'mtls_crl': 'Certificate Revocation List',
    'namespace_add': 'Add namespace',
    'namespace_edit': 'Edit namespace',
    'namespace_delete': 'Delete Namespace',
    'namespace_delete_message': 'Are you sure you want to delete this Namespace?',
    'namespaces': 'Namespaces',
    'net_int_config': 'Interfaces',
    'net_int_config_add_interface': 'Add interface',
    'net_int_config_add_to_bond': 'Add to bond',
    'net_int_config_bond_edit': 'Edit bond',
    'net_int_config_break_bond': 'Break bond',
    'net_int_config_break_bond_backend_message': 'Let backend auto assign',
    'net_int_config_break_bond_cancel_text': 'Return to Net-int configuration',
    'net_int_config_break_bond_confirm_message': 'This bond has no groups and the interfaces will be restore to their original state.',
    'net_int_config_break_bond_groups_message': 'Please assign IP groups back to interfaces.',
    'net_int_config_break_bond_vlans_message': 'Please assign vlan back to interfaces.',
    'net_int_config_create_bond': 'Add Bond',
    'net_int_config_create_bond_message': 'Give your bond a name and select the interfaces to bond.',
    'net_int_config_delete_vlan': 'Delete VLAN',
    'net_int_config_delete_vlan_message': 'Are you sure you want to delete this VLAN?',
    'net_int_config_edit_vlan': 'Edit VLAN',
    'net_int_config_interface_details': 'Interface details',
    'net_int_config_interface_edit': 'Edit interface',
    'net_int_config_interface_name': 'Interface name',
    'net_int_config_interface_offload': 'Interface offload',
    'net_int_config_interface_remove': 'Remove interface from bond',
    'net_int_config_interface_remove_message': 'Are you sure you want to remove this bonded interface?',
    'net_int_config_ip_add': 'Add IP',
    'net_int_config_mtu': 'MTU',
    'net_int_config_offload': 'Offload',
    'net_int_config_onboot': 'Onboot',
    'net_int_config_speed': 'Speed',
    'net_int_config_vlan_add': 'Add VLAN',
    'no_access': 'Access denied',
    'no_access_instructions': 'Copy and forward the following to your system administrator to request access.',
    'no_access_message': 'Sorry, you do not have permission to view this page.',
    'no_access_message_access_path': 'is trying to access the path:',
    'no_access_message_endpoint': 'The API endpoint is:',
    'no_access_message_required_method': 'which requires the method:',
    'no_access_message_user': 'The user:',
    'no_access_requirement': 'Access requirement',
    'notification_clear_selected': 'Clear selected notification',
    'notification_copy_debug_info': 'Copy debug info',
    'notifications_clear': 'Clear All Notifications',
    'notifications_clear_error': 'Clear errors',
    'notifications_clear_warning': 'Clear warning',
    'notifications_delete_selected': 'Delete selected notifications',
    'notifications_see_all': 'See All Notifications',
    'onboard_add_adc': 'Add a Loadbalancer',
    'onboard_add_adc_message': 'We offer loadbalancer support from multiple suppliers, choose one below.',
    'onboard_add_organization': 'Add your organization',
    'onboard_add_organization_message': 'To use the Loadbalancer portal you will need to add some organization details.',
    'onboard_add_users': 'Add users',
    'onboard_add_users_message': 'You can invite multiple users to manage and maintain your Loadbalancers.',
    'onboard_continue_to_portal': 'Continue To Portal',
    'onboard_current_user': 'The current logged in user is already associated to an organization.',
    'onboard_do_it_later': 'Do it later',
    'onboard_edit_organization': 'Edit organization',
    'onboard_organization_private_key': 'Organization Private Key',
    'onboard_organization_private_key_message': 'Please confirm your password in order to download your organization private key.',
    'onboard_setup_issue_message': 'If you are having an issue onboarding this organization, try using the support button bottom right or confirming this will log you out so you can try again.',
    'onboard_setup_issue_title': 'Issue setting up this organization',
    'onboard_user_already_assigned': 'User already assigned',
    'organization_change_denied': 'You don\'t have permissions to change these details.',
    'organization_send_continue': 'Send invite & continue',
    'organization_title': 'Organization',
    'physical_adv_conf': 'Physical - advanced configuration',
    'physical_adv_conf_conn_trac_table_size': 'Connection tracking table size',
    'physical_adv_conf_console': 'Console',
    'physical_adv_conf_firewall_connections': 'Firewall connections',
    'physical_adv_conf_http_proxy': 'HTTP proxy',
    'physical_adv_conf_internet_access': 'Internet access',
    'physical_adv_conf_proxy_address': 'proxy address',
    'physical_adv_conf_proxy_password': 'proxy password',
    'physical_adv_conf_proxy_port': 'proxy port',
    'physical_adv_conf_proxy_username': 'proxy username',
    'physical_adv_conf_smtp_address': 'SMTP address',
    'physical_adv_conf_smtp_password': 'SMTP password',
    'physical_adv_conf_smtp_port': 'SMTP port',
    'physical_adv_conf_smtp_relay': 'SMTP relay',
    'physical_adv_conf_smtp_server_address': 'SMTP server address',
    'physical_adv_conf_smtp_username': 'SMTP username',
    'pipeline': 'Pipeline',
    'pipeline_add': 'Add pipeline',
    'pipelines': 'Pipelines',
    'platform_hyperV_description_long': 'Microsoft Hyper-V is a hypervisor-based virtualization platform developed by Microsoft. It allows users to create and manage virtual machines (VMs) on a Windows-based system. Hyper-V enables multiple operating systems to run on a single physical machine by virtualizing the hardware resources.',
    'platform_hyperV_description_short': 'Hyper-V lets you run multiple operating systems as virtual machines on Windows. ',
    'platform_kvm_description_long': 'The KVM hypervisor for Kernel-based virtual machines offers full virtualization capabilities. It provides each VM with all typical services of the physical system, including virtual BIOS and virtual hardware, such as processor, memory, storage, and network cards. As a result, every VM completely simulates a physical machine.',
    'platform_kvm_description_short': 'KVM provides each VM with all services of the physical system and virtual hardware.',
    'platform_nutanix_description_long': 'This enterprise-ready hypervisor from Nutanix is included with every Nutanix node. As a hypervisor designed for HCI and the Enterprise Cloud, AHV provides the option to lower software licensing costs without compromising on features and functionality.',
    'platform_nutanix_description_short': 'Nutanix AHV is an enterprise-ready hypervisor included with every Nutanix node. ',
    'platform_virtualBox_description_long': 'Oracle VM VirtualBox is an open-source, cross-platform virtualization software that enables users to create and manage virtual machines on their host systems. Developed by Oracle, VirtualBox supports a wide range of guest operating systems, making it a versatile tool for development, testing, and running multiple operating systems on a single physical machine.',
    'platform_virtualBox_description_short': 'VirtualBox is an open source version of VMWare’s hypervisor.',
    'platform_vmWare_description_long': 'VMware ESXi is a bare-metal hypervisor and virtualization platform developed by VMware. It allows users to create and manage virtual machines (VMs) on a server without the need for a host operating system. ESXi is a Type 1 hypervisor, meaning it runs directly on the hardware, providing efficient and direct control over system resources.',
    'platform_vmWare_description_short': 'VMware ESXi is a bare-metal hypervisor developed by VMware for vSphere. ',
    'platform_xen_description_long': 'Xen provides services that allow multiple computer operating systems to execute on the same computer hardware concurrently. The Xen Project hypervisor is an open-source type-1 or bare-metal hypervisor, allowing many instances of an operating system or different operating systems to run in parallel on a single machine (or host).',
    'platform_xen_description_short': 'Xen is a free and open-source type-1 hypervisor.',
    'policies_privacy': 'Loadbalancer.org, Inc. Privacy Policy',
    'policies_terms_of_service': 'Loadbalancer.org, Inc. Terms of Service',
    'portal_management': 'Portal management',
    'portal_management_adoption_details': 'Adoption details',
    'portal_management_adoption_status': 'Adoption status',
    'portal_management_adoption_submitted': 'Adoption submitted',
    'portal_management_connection_submitted': 'Connection details submitted',
    'portal_management_ip_address': 'Management IP address',
    'portal_management_login_email': 'Portal login email',
    'portal_management_login_password': 'Portal login password',
    'portal_management_not_submitted': 'Not submitted',
    'portal_management_remove_adc': 'Remove ADC from Portal',
    'portal_management_remove_adc_message': 'Are you sure you want to remove this ADC from Portal?',
    'portal_management_shuttle_enabled': 'Enable shuttle',
    'portal_management_shuttle_setup': 'Shuttle setup and is ready for adoption',
    'portal_management_subnets': 'Management subnets',
    'prometheus_enable_exporter_ha_proxy': 'Enabled Layer 7 Exporter',
    'prometheus_enable_exporter_node': 'Enabled Node Exporter',
    'prometheus_error_duplicate': 'The port and IP can\'t be same as the other exporter',
    'prometheus_exporter_port': 'Exporter port',
    'prometheus_node_exporter': 'Node exporter',
    'prometheus_set_exporters': 'Set exporters',
    'pulse_conf_fail_over_limit': 'Limit must be between 2000 and 10000',
    'pulse_conf_interval': 'Interval must be between 1000 and 10000',
    'pulse_ha_auto_fail_back': 'Auto fail back',
    'pulse_ha_auto_fail_back_join': 'autoFailBack',
    'pulse_ha_change_ip': 'To change the IP address and port number that PulseHA is listening on, you will need to remove this node from the cluster first.',
    'pulse_ha_cluster_health': 'Cluster health',
    'pulse_ha_cluster_status': 'PulseHA cluster status',
    'pulse_ha_config': 'PulseHA configuration',
    'pulse_ha_current_settings': 'Current settings.',
    'pulse_ha_error': 'There is an error with PulseHA',
    'pulse_ha_fail_over_interval': 'Failover interval*',
    'pulse_ha_fail_over_limit': 'Failover limit*',
    'pulse_ha_global_config': 'PulseHA global configuration',
    'pulse_ha_health_check_interval': 'Health check interval*',
    'pulse_ha_node_cluster': 'This node is in a cluster',
    'pulse_ha_port': 'PulseHA port',
    'rbac_hint_update_yourself': 'You can\'t update your own permissions',
    'rbac_hint_group_association_delete': 'You can\'t delete a group you are associated with.',
    'rbac_hint_group_association_update': 'You can\'t edit a group you are associated with.',
    'rbac_hint_role_association_delete': 'You can\'t delete a role you are associated with.',
    'rbac_hint_role_association_update': 'You can\'t edit a role you are associated with.',
    'rbac_group_add_role': 'Add group',
    'rbac_group_admin_access_text': 'Admin access',
    'rbac_group_assign_role': 'Assign role to group',
    'rbac_group_assign_role_select': 'Select roles',
    'rbac_group_assign_role_selected': 'Selected role(s)',
    'rbac_group_delete_role': 'Delete group',
    'rbac_group_details': 'Group details',
    'rbac_group_edit_role': 'Edit group',
    'rbac_group_management': 'Select users',
    'rbac_group_management_selected': 'Selected user(s):',
    'rbac_group_name': 'Group name',
    'rbac_group_ready_message': 'Please check your details. You can edit your details or hit the submit button below when ready.',
    'rbac_groups_add_group': 'Add group',
    'rbac_groups_cancel_text': 'Return to Groups',
    'rbac_groups_delete_group': 'Delete group',
    'rbac_groups_edit_group': 'Edit group',
    'rbac_groups_no_roles': 'You do not have any groups or roles setup',
    'rbac_groups_selected_groups': 'Selected groups',
    'rbac_role_details': 'Role details',
    'rbac_role_duplicate': 'Duplicate Role',
    'rbac_role_duplicated_from': 'Duplicated from',
    'rbac_role_management': 'Role management',
    'rbac_role_name': 'Role name',
    'rbac_role_ready_message': 'Please check your details. You can edit your details or hit the submit button below when ready.',
    'rbac_roles_add_role': 'Add role',
    'rbac_roles_admin_access_text': 'Admin access',
    'rbac_roles_cancel_text': 'Return to Roles',
    'rbac_roles_delete_role': 'Delete role',
    'rbac_roles_edit_collapse_all': 'Collapse all',
    'rbac_roles_edit_expand_all': 'Expand all',
    'rbac_roles_edit_role': 'Edit role',
    'rbac_users_add_user': 'Add user',
    'rbac_users_delete_selected': 'Delete selected users',
    'rbac_users_details': 'User details',
    'rbac_users_disable_user': 'Disable user',
    'rbac_users_edit_user': 'Edit user',
    'rbac_users_edit_user_permissions': 'Edit user permissions',
    'rbac_users_invite_user': 'Invite user',
    'rbac_users_ready': 'Ready to add user',
    'rbac_users_return_to_users': 'Return to Users',
    'rbac_users_roles_groups_message': 'You must add at least one role or group in order to proceed.',
    'rbac_users_submit_user': 'Submit user',
    'rbac_users_submit_user_warning': 'You are editing the current user\'s password. By submitting you will be required to log in again with your new password. Do you wish to proceed?',
    'rbac_users_update_message': 'A user can edit their personal details under account settings.',
    'rbac_users_update_permissions': 'Update permissions',
    'rbac_widget_no_permissions': 'You don\'t have permission to view this widget',
    'region_add': 'Add region',
    'region_add_new': 'Add new region',
    'region_delete': 'Delete region',
    'region_delete_multiple_regions': 'Delete multiple regions',
    'region_delete_selected_subnets': 'Delete selected subnets',
    'region_deleting_regions': 'Deleting regions',
    'region_edit': 'Edit region',
    'region_no_subnets_hint': 'No subnets to view',
    'region_view_subnets': 'View subnet(s)',
    'registration_already_have_account': 'Already have an account?',
    'registration_error': 'Registration Error',
    'registration_policy_message': 'By clicking on Create Account, you agree to the our',
    'registration_sign_up_message': 'Sign up for a free Loadbalancer experience today',
    'registration_success_msg': 'Success! We\'ve sent you an activation email for you to verify and complete your registration.',
    'registration_title': 'Sign up to Portal.',
    'relogin-sso-click': 'Click to log back in with SSO.',
    'relogin_cert_expired_text': 'Your certificate has expired. Please logout',
    'relogin_requesting_auth_token': 'Requesting AUTH token',
    'reports_distribution_state': 'Distribution state',
    'resources_no_images_available': 'There are currently no images for the selected platform',
    'restart_page_sub_title': 'This may take a few minutes, please wait and you will be re-directed to the login page once completed.',
    'restart_page_title': 'Restarting system',
    'routing_add_route': 'Add route',
    'routing_default_gateway': 'Default gateway',
    'routing_delete_route': 'Delete route',
    'routing_static_routes': 'Static routes',
    'routing_via_interface': 'Via interface',
    'saml_download_xml': 'Download XML',
    'saml_modal_message': 'Please enter your organization email address',
    'saml_modal_title': 'SAML Login',
    'saml_remove_message': 'Are you sure you want to remove the SAML configuration from your organization?',
    'saml_remove_title': 'Remove SAML configuration',
    'saml_setup_form_label': 'Paste in your metadata link here:',
    'saml_setup_form_enforce': 'Enforce SAML for all users',
    'saml_setup_message': 'If you are unsure on how to configure SAML access, please contact our support team.',
    'saml_setup_need_help': 'Need help?',
    'saml_title': 'SAML',
    'saml_title_entityId': 'Entity ID/ Audience URL',
    'saml_title_issuer': 'Issuer ID',
    'saml_title_message': 'SAML allows login through your SAML identity provider single sign-on functionality.',
    'saml_title_message_help': 'For help on how to configure SAML',
    'saml_title_message_help_link': 'contact our support team',
    'saml_title_name_id': 'Name ID Format',
    'saml_title_sso_url': 'Single Sign-On URL',
    'saml_title_what_is': 'What is SAML?',
    'saml_title_xml_message': 'If your SAML identity provider supports automatic configuration, you can download the config in XML below.',
    'saml_upgrade_message': 'Enhance your organisation security by using SAML for your portal access.',
    'saml_upgrade_title': 'Upgrade to use SAML',
    'schedule_add': 'Add Schedule',
    'schedule_clear_filters': 'Clear Filters',
    'schedule_create': 'Create schedule',
    'schedule_delete': 'Delete Schedule',
    'schedule_delete_message': 'You are sure want to delete this schedule?',
    'schedule_edit': 'Edit schedule',
    'schedule_type': 'Schedule Type',
    'schedule_update': 'Update Schedule',
    'scheduled_date_time': 'Scheduled Date/Time',
    'scheduled_date_time_utc': 'Coordinated Universal Time',
    'scheduled_type': 'Scheduled Type',
    'scheduled_update': 'Scheduled Update',
    'scheduler': 'Scheduler',
    'scheduler_error_message_no_adc': 'No ADC with this ID exists',
    'scheduler_local_time': 'Local time',
    'scheduler_save_schedule': 'Save Schedule',
    'schedules_empty_message': 'Set a convenient time to update and back up your appliances, with 1 year of history.',
    'schedules_empty_title': 'No schedules added yet.',
    'schedules_upgrade_message': 'Schedules enable you to backup and update your ADCs at any given time and on a reoccurring basis.',
    'schedules_upgrade_title': 'Upgrade to asset scheduling.',
    'search_no_results': 'No results found for',
    'security': 'Security',
    'security_affected_version': 'Affected Version(s)',
    'security_certs_upgrade_message': 'Enhance your organisation security by using certificates for your portal.',
    'security_certs_upgrade_title': 'Upgrade to create certificates.',
    'security_cve_details': 'CVE Details',
    'security_dashboard': 'Dashboard',
    'security_how_to_fix': 'How to fix',
    'security_insights': 'Insights',
    'security_insights_label': 'Security insights',
    'security_insights_upgrade_message': 'Enhance your organisation security by using insights for your portal.',
    'security_insights_upgrade_title': 'Upgrade to use insights',
    'security_more_details': 'More Details',
    'security_need_help': 'Need Help?',
    'security_nist_details': 'NIST Details',
    'security_operational_risk': 'Operational Risk',
    'security_our_recommendation': 'Our Recommendation',
    'security_published': 'Published',
    'security_published_last': 'Last Modified',
    'security_publisher': 'Publisher',
    'security_risk': 'Security Risk',
    'security_severity_score': 'Severity Score',
    'security_update_adc': 'Update ADC',
    'security_update_adc_message': 'Update not yet supported for this vendor',
    'security_vulnerability_id': 'Vulnerability ID',
    'security_vulnerability_info': 'Vulnerability Info',
    'service_details': 'Service details',
    'service_details_add_backend': 'Add backend',
    'service_details_add_backend_disabled': 'Layer 4 currently doesn\'t support multiple backends',
    'service_details_edit_backend': 'Edit backend',
    'service_details_error_type': 'No matching service types',
    'services_abort_on_close': 'Abort on close',
    'services_accept_invalid_http_requests': 'Accept invalid HTTP requests',
    'services_accept_invalid_http_response': 'Accept invalid HTTP response',
    'services_add_backend_service': 'Add backend service',
    'services_add_real_server': 'Add real server',
    'services_agent_port': 'Agent port',
    'services_application_cookie_name': 'Application cookie name',
    'services_apply_all': 'Apply all',
    'services_backend_connections': 'Backend connections',
    'services_backend_mode_disabled_message': 'The backend mode is disabled as the linked frontend(s) is HTTP.',
    'services_backend_source_address': 'Backend source address',
    'services_balance_mode': 'Balance mode',
    'services_check_port': 'Check port',
    'services_clear_stick_table_on_drain': 'Clear stick table on drain',
    'services_client_connection_timeout': 'Client connection timeout',
    'services_compression': 'Compression',
    'services_backend_configuration': 'Backend configuration',
    'services_conn_distribution_method': 'Connection distribution method',
    'services_connection_redispatch': 'Connection redispatch',
    'services_count': 'count',
    'services_delete': 'Delete service',
    'services_disabled_on_start': 'Disabled on start',
    'services_drain': 'Drain service',
    'services_duplicate_backend_service': 'Duplicate backend service',
    'services_duplicate_frontend': 'Duplicate frontend',
    'services_duplicate_real_server': 'Duplicate real server',
    'services_edit_backend_service': 'Edit backend service',
    'services_edit_frontend': 'Edit frontend',
    'services_edit_real_server': 'Edit real server',
    'services_enable_client_conn_timeout': 'Enable client connection timeout',
    'services_enable_duplicates': 'Enable duplicates',
    'services_enable_gzip_compression': 'Enable gzip compression',
    'services_enable_hsts': 'Enable HSTS',
    'services_enable_server_conn_timeout': 'Enable server connection timeout',
    'services_enable_ssl_termination': 'Enable SSL termination',
    'services_enable_tproxy': 'Enable TProxy',
    'services_enable_x_forwarded': 'Enable X-forwarded-for header',
    'services_enable_zero_round_trips': 'Enable zero round trips',
    'services_encrypt_to_real_server': 'Encrypt to real server',
    'services_ensure_requests_untouched': 'Ensure that all 0-RTT requests are unchanged (the request can be performed multiple times without having a different result) before enabling this feature',
    'services_external_check_script': 'External check script',
    'services_feedback_agent_interval': 'Feedback agent interval',
    'services_force_to_https': 'Force to HTTPS',
    'services_frontend_configuration': 'Frontend configuration',
    'services_frontend_floating_ip': 'This is the frontend floating IP address and the floating IP mask.',
    'services_frontend_floating_port': 'This is the frontend floating IP ports.',
    'services_frontend_mode_disabled_message': 'The frontend mode is disabled as the linked backend(s) is TCP',
    'services_greater_than': 'Greater than',
    'services_greater_than_equals': 'Greater than or equals',
    'services_halt': 'Halt service',
    'services_health_check_type': 'Health check type',
    'services_host_header': 'Host header',
    'services_hsts_timeout': 'HSTS timeout',
    'services_http_cookie_max_idle': 'HTTP cookie max idle',
    'services_http_cookie_max_life': 'HTTP cookie max life',
    'services_http_cookie_name': 'HTTP cookie name',
    'services_http_idle_connection_reuse': 'HTTP idle connection reuse',
    'services_http_pipeline_mode': 'HTTP pipeline mode',
    'services_http_pretend_keepalive': 'HTTP pretend keepalive',
    'services_http_request_timeout': 'HTTP request timeout (DDos protection)',
    'services_https_redirect_code': 'HTTPS redirect code',
    'services_individual_ports': 'Individual port(s)',
    'services_layer_4_mode': 'Layer 4 mode',
    'services_layer_7_mode': 'Layer 7 mode',
    'services_less_than': 'Less than',
    'services_less_than_equals': 'Less than or equals',
    'services_min_real_servers': 'Min real servers',
    'services_minimum_conns': 'Minimum connections',
    'services_mode': 'Service mode',
    'services_monitor_configuration': 'Monitor configuration',
    'services_monitor_uri': 'Monitor URI',
    'services_name': 'Service name',
    'services_no_backends': 'No backends found',
    'services_notification_changes': 'The configuration of the following services has been changed:',
    'services_notification_commit_message': 'Click here to visit the services page to commit your changes.',
    'services_number_of_servers': 'Number of real servers',
    'services_number_real_servers_message': 'The number of real servers you wish to create.',
    'services_online': 'Online service',
    'services_port_ranges': 'Port range(s)',
    'services_ports_placeholder': 'Port(s)',
    'services_proxy_protocol': 'Proxy protocol',
    'services_re_encrypt_to_backend': 'Re-encrypt to backend',
    'services_real_server': 'Real server',
    'services_real_server_add': 'Add real server',
    'services_real_server_configuration': 'Real server configuration',
    'services_real_server_confirm_message': 'Are you sure you want to lose the changes to the form?',
    'services_real_server_confirm_title': 'Confirm lose changes',
    'services_real_server_ip': 'IP Address',
    'services_real_server_name': 'Real server name',
    'services_real_server_port': 'Real server port',
    'services_real_server_select': 'Select existing real server',
    'services_real_server_usage': 'Real server usage',
    'services_real_servers': 'Real servers',
    'services_request_to_send': 'Request to send',
    'services_response_expected': 'Response expected',
    'services_restart': 'System services',
    'services_return_to_service_details': 'Return to service details',
    'services_search_backend': 'Search within this backend',
    'services_send_proxy_protocol': 'Send proxy protocol',
    'services_server_timeout': 'Server timeout',
    'services_slow_start_time': 'Slow start time',
    'services_table_size': 'Table size',
    'services_tcp_keep_alive': 'TCP keep alive',
    'services_tcp_keepalive': 'TCP keepalive',
    'services_timeout': 'Timeout',
    'services_tunnel_timeout': 'Tunnel timeout',
    'services_xff_ip_position': 'XFF IP position',
    'shutdown_completed_page_title': 'Shutdown complete',
    'shutdown_completed_sub_title': 'System shutdown has successfully completed.',
    'shutdown_page_sub_title': 'Your system is now shutting down.',
    'shutdown_page_title': 'System shutdown',
    'shuttle_install_complete': 'Successfully connected',
    'shuttle_install_message_credentials': 'Please visit the portal management page on your appliance and complete the adoption form.',
    'shuttle_install_message_token': 'Please visit your appliance that you are setting up as a shuttle  and run the above copied command.',
    'shuttle_install_wait': 'Waiting for adoption...',
    'shuttle_no_vendor_message': 'The vendor that has been selected doesn\'t match our list of supported vendors',
    'shuttle_no_vendor_title': 'No vendor found',
    'snmp_conf_delete_user_message': 'Are you sure you wish to delete this user from your configuration?',
    'snmp_conf_protocol_in_use': 'Using Protocol: ',
    'snmp_conf_select_version': 'Select protocol version',
    'snmp_conf_settings_add': 'Add SNMP settings',
    'snmp_conf_settings_edit': 'Edit SNMP settings',
    'snmp_conf_snmp_auth_passphrase': 'Authorization passphrase',
    'snmp_conf_snmp_community': 'Community',
    'snmp_conf_snmp_contact': 'Contact',
    'snmp_conf_snmp_enable_v2': 'V2',
    'snmp_conf_snmp_enable_v3': 'V3',
    'snmp_conf_snmp_location': 'Location',
    'snmp_conf_snmp_privacy_alg': 'Privacy algorithm',
    'snmp_conf_snmp_privacy_passphrase': 'Privacy passphrase',
    'snmp_conf_snmp_protocol_version': 'SNMP protocol version',
    'socket_service_reconnect_message': 'Attempting to reconnect to the websocket',
    'ssl_certificates': 'SSL certificates',
    'ssl_certificates_usage': 'SSL certificate usage',
    'ssl_cipher_lists': 'SSL cipher lists',
    'ssl_offload_allowed_hostnames': 'Allowed Hostnames',
    'ssl_offload_cipher_list': 'Cipher list',
    'ssl_offload_delete_certificate': 'Delete certificate',
    'ssl_offload_delete_termination_title': 'Delete SSL certificate association',
    'ssl_offload_denied_hostnames': 'Denied Hostnames',
    'ssl_offload_hostnames_add_allowed': 'Add allowed',
    'ssl_offload_hostnames_add_denied': 'Add denied',
    'ssl_offload_hostnames_allowed': 'Hostnames Allowed',
    'ssl_offload_hostnames_denied': 'Hostnames Denied',
    'ssl_offload_hostnames_placeholder': 'Hostname(s)',
    'ssl_offload_manage_certificate': 'Manage certificate',
    'ssl_offload_manage_cipher_list': 'Manage cipher list',
    'ssl_offload_remove_ssl_cert_association': 'Remove SSL certificate association',
    'ssl_offload_remove_ssl_cert_association_message': 'By deleting this SSL cert association you will disable SSL termination. Are you sure you want to delete this SSL cert association?',
    'static_ip': 'Static IP',
    'static_ip_add': 'Add static IP',
    'static_ip_change': 'IP Changed',
    'static_ip_change_message': 'The IP you are changing is assign to a service and that service will need to be reloaded',
    'static_ip_delete_multiple_ips': 'Delete multiple IPs',
    'static_ip_delete_selected': 'Delete selected static IPs',
    'static_ip_edit': 'Edit static IP',
    'static_ip_no_usage': 'no usage data available',
    'static_ip_not_in_use': 'Not in use',
    'static_ip_usage': 'Static IP usage',
    'static_ip_usage_for_ip': 'Usage for IP',
    'static_ip_used_in': 'Used in',
    'static_route': 'Route',
    'static_route_add': 'Add route',
    'static_route_default_gw_change': 'Change default route gateway address',
    'static_route_default_gw_change_message': 'You are about to change the default route gateway. Are you sure you wish to do this?',
    'static_route_delete': 'Delete static route',
    'static_route_delete_multiple_routes': 'Delete multiple routes',
    'static_route_delete_selected': 'Delete selected routes',
    'static_route_edit': 'Edit route',
    'static_route_gateway': 'Gateway',
    'static_route_group': 'Group',
    'static_route_range': 'IP range',
    'static_route_type': 'Type',
    'static_routes': 'Routes',
    'storage_download_latest': 'Download latest',
    'storage_download_restriction_notification': 'You currently don\'t have an organisation key, you need to request one from your administrator.',
    'storage_empty_message': 'When you create a backup of your ADC or other services, it will appear here.',
    'storage_empty_title': 'No backups added yet.',
    'storage_modal_id_message': 'The ADC appliance ID is required as a password for the encrypted file, you will not be able to use the backup without this ID:',
    'storage_modal_id_title': 'Backup Archive Password',
    'subscriptions_adc_connections': 'ADC Connections',
    'subscriptions_add_more_connections': 'Add an additional 10 ADC connections to your Portal for only',
    'subscriptions_annual_plan': 'Annual Plan',
    'subscriptions_backup_history': 'With 1 Year history',
    'subscriptions_billed_at': 'Billed at',
    'subscriptions_book_a_demo': 'Book a demo',
    'subscriptions_business': 'Portal business',
    'subscriptions_business_subtitle': 'For multiple teams',
    'subscriptions_current_plan': 'Current plan',
    'subscriptions_enterprise_demo_message': 'Enterprise-ready! Contact our team for a custom quote.',
    'subscriptions_for_starter_projects': 'For starter projects',
    'subscriptions_free': 'Portal free',
    'subscriptions_monthly_plan': 'Monthly Plans',
    'subscriptions_need_more_connections': 'Need more connections?',
    'subscriptions_per_adc': 'per ADC',
    'subscriptions_pro': 'Portal pro',
    'subscriptions_pro_subtitle': 'For professionals',
    'subscriptions_support_level': 'Support Level',
    'subscriptions_support_message': 'Portal Platform (In your timezone)',
    'subscriptions_support_type': 'Account & Billing',
    'subscriptions_tailored': 'Portal tailored',
    'subscriptions_tailored_subscription_message': 'Our Tailored subscription is designed to work for large enterprises. Book a free demo with us today.',
    'subscriptions_tailored_subtitle': 'For total customization',
    'support': 'Support',
    'support_close_ticket': 'Close Ticket',
    'support_close_ticket_message': 'Are you sure you want to close this ticket, it will no longer be displayed in your organization\'s tickets.',
    'support_create_ticket': 'Create ticket',
    'support_delete_ticket': 'Delete ticket',
    'support_get': 'Get support',
    'support_send_feedback': 'Send Feedback',
    'support_technical_archive_success': 'Support archive downloaded',
    'support_technical_contact_us': 'Contact us',
    'support_technical_create_support_archive': 'Creating support archive. Please wait...',
    'support_technical_create_support_archive_error': 'An error was encountered during the creation of the support archive.',
    'support_technical_download_info': 'This page generates an archive of all the required files, which is then downloaded to your PC.',
    'support_technical_info': 'When contacting Loadbalancer.org support, you may be asked to supply the loadbalancer\'s configuration and log files.',
    'support_technical_recommended': 'We have already selected the recommended download option for you.',
    'support_technical_support_download': 'Technical support download',
    'support_telephone': 'Telephone support',
    'support_tickets_empty_message': 'If you have an issue, then please contact one of our team.',
    'support_tickets_empty_title': 'No support tickets yet.',
    'system_control_confirm_restart': 'Are you sure that you wish to restart the load balancer?',
    'system_control_confirm_shutdown': 'Are you sure that you wish to shut down the Load Balancer?',
    'system_control_confirm_unlock': 'Are you sure you want to unlock your loadbalancer?<br>If it is locked for a genuine reason you could break your box!',
    'system_control_logout_info': 'You will be logout of the client',
    'system_control_reboot_load_balancer_message': 'Your load balancer is restarting and will be back online shortly',
    'system_control_restart_lb': 'Restart load balancer',
    'system_control_shutdown_lb': 'Shutdown load balancer',
    'system_control_unlock': 'Unlock',
    'system_control_view_error_log': 'View error log',
    'system_control_error_log': 'Error log',
    'system_overview': 'System overview',
    'system_overview_details': 'System details',
    'system_update_change_log': 'Change log',
    'system_update_confirm_unlock': 'Are you sure you want to unlock your loadbalancer?<br>If it is locked for a genuine reason you could break your box!',
    'system_update_confirm_update_message': 'Are you sure that you wish to update the load balancer?',
    'system_update_current_version': 'Current version',
    'system_update_failed': 'Unable to connect to the repo. Manual updates only.',
    'system_update_manual_update': 'Manual update',
    'system_update_online_update': 'Online update',
    'system_update_os_update': 'OS update',
    'system_update_os_version': 'OS version',
    'system_update_package_to_update': 'Packages to update: ',
    'system_update_package_to_update_major': 'Major version to update: ',
    'system_update_package_update_failed': 'Package update failed',
    'system_update_package_updating': 'Updating packages',
    'system_update_package_wait': 'Please wait.....',
    'system_update_pending_version': 'Pending version',
    'system_update_release': 'Release',
    'system_update_restart': 'Your loadbalancer requires a restart',
    'system_update_restart_required': 'One or more packages require your loadbalancer to be restarted. Clicking restart will log you out. Your loadbalancer may be unavailable for a few minutes',
    'system_update_software_update': 'Software update',
    'system_update_system_packages_up_to_date': 'All packages are up to date',
    'system_update_system_up_to_date': 'Everything is up to date',
    'system_update_update_archive': 'Please select the update archive',
    'system_update_version': 'Version number',
    'system_updates': 'System updates',
    'tab_no_access': 'You do not have permission to view this tab.',
    'table_close_overlay': 'Close table overlay',
    'table_component_all': 'All ',
    'table_component_all_selected_page': ' rows on this page are selected.',
    'table_component_are_selected': ' are selected.',
    'table_component_clear_selection': 'Clear selection.',
    'table_go_to_page': 'Go to page',
    'table_hidden_columns': 'Hidden columns',
    'table_landscape_on_small_devices': 'landscape on small devices',
    'table_no_data': 'No data to display',
    'table_show_records': 'Show records',
    'tables_are_best_viewed': 'Tables are best viewed in',
    'tags': 'Tags',
    'tags_duplicate_message': 'This tag already exists (it may be in lowercase)',
    'tags_max-length_message': 'This tag is too long, max character',
    'tags_max_message': 'You\'ve reach the maximum number of tags allowed',
    'tags_min-length_message': 'This tag is too short',
    'tags_place_holder': 'Add a tag and press enter',
    'template_selector_import_template': 'Import a template',
    'template_selector_load_saved_template': 'Load saved template',
    'template_selector_remove_template': 'Remove template',
    'template_selector_select_service_type': 'Please select a template to configure',
    'ticket': 'Ticket',
    'ticket_type': 'Ticket Type',
    'ticket_update': 'Update Ticket',
    'tickets_all': 'All Tickets',
    'update_settings': 'Update Settings',
    'upload_change_file': 'Change file',
    'upload_choose_file': 'Choose file',
    'upload_pem_pfx': 'Upload (PEM / PFX)',
    'upload_update_pem': 'Update PEM',
    'upload_update_pem_pfx': 'Update (PEM / PFX)',
    'upload_update_pfx': 'Update PFX',
    'usage_no_usage': 'no usage data available',
    'usage_not_in_use': 'Not in use',
    'usage_used_in': 'Used in',
    'user_activation_passcode_invite_message': 'Your invitee will require a one-time passcode to activate their account. Please make a note of this and send it to them.',
    'user_add_new_user_message': 'Please enter your password to send invite',
    'user_copy_passcode': 'Copy passcode',
    'user_delete_group': 'Delete group',
    'user_delete_group_message': 'Are you sure you want to delete this group?',
    'user_delete_message_endurance': 'Are you sure you want to delete this user from this appliance?',
    'user_delete_message_portal': 'Are you sure you want to delete this user?',
    'user_delete_users_message_portal': 'Are you sure you want to delete the selected users?',
    'user_delete_portal': 'Delete user association',
    'user_delete_role': 'Delete role',
    'user_delete_role_message': 'Are you sure you want to delete this role?',
    'user_hint_delete': 'You can\'t delete the only owner',
    'user_hint_delete_yourself': 'You can\'t delete yourself',
    'user_hint_edit': 'You can\'t edit the only owner',
    'user_interface': 'User interface',
    'user_interface_api_port': 'API port',
    'user_interface_confirm': 'Confirm userService interface',
    'user_interface_reload_model_text': 'Httpd and PulseHA are reloading. You will be logged out and reload in',
    'user_interface_set_interface': 'Set user interface',
    'user_interface_ssh_enabled': 'SSH enabled',
    'user_interface_ssh_port': 'SSH port',
    'user_management': 'User Management',
    'user_please_confirm_copy_passcode': 'Please confirm you have copied the passcode',
    'user_send_invite': 'Send invite',
    'users_add_user': 'Add user',
    'users_edit_user': 'Edit user',
    'users_list_last_login_in': 'Last logged in',
    'users_list_last_otp_enabled': 'OTP enabled',
    'view_config': 'View configuration',
    'view_config_certs': 'Certificates',
    'view_config_ciphers': 'Ciphers',
    'view_config_data_services': 'Data services',
    'view_config_fallback_server': 'Fallback pages',
    'view_config_fip': 'FIPs',
    'view_config_gslb': 'GSLB',
    'view_config_haproxy': 'HAProxy',
    'view_config_healthchecks': 'Health Checks',
    'view_config_ip_groups': 'IP Groups',
    'view_config_ipvsdirector': 'IP Virtual Service Director',
    'view_config_lbconfig': 'JSON configuration file',
    'view_config_lbconfig_message': 'Unable to fetch json configuration file',
    'view_config_message': 'Unable to fetch configuration file',
    'view_config_nic': 'Network configuration',
    'view_config_pulseha': 'PulseHA',
    'view_config_pulseha_message': 'Unable to fetch pulse HA configuration file',
    'view_config_rbac': 'RBAC',
    'view_config_routing_table': 'Routing table',
    'view_config_routing_table_message': 'Unable to fetch routing table configuration file',
    'view_config_service_ips': 'Service IPs',
    'view_config_sidecar': 'Sidecar',
    'view_config_sips': 'SIPs',
    'view_config_snmp': 'SNMP Configuration',
    'view_config_system': 'System',
    'view_config_unknown': 'Unknown config',
    'virtual_service_widget_frontend_overview': 'Frontend overview',
    'widget_collecting_data': 'Collecting data',
    'widget_everything_good': 'Everything is looking good',
    'widget_ha_proxy_message': 'You need to restart Ha Proxy as ALL of your services are in a pending state',
    'widget_no_data_error': 'Unable to get some or all of the widget data.',
    'widget_no_data_collected': 'No data',
    'widget_no_permission': 'You do not have permission to view this widget',
    'widget_upgrade_options': 'Upgrade options',
    'wizard_change_template': 'Change Template',
    'wizard_change_template_text': 'Changing the template will delete all current form data. Do you wish to proceed?',
    'wizard_leaving_partner_mode': 'Leaving partner mode',
    'wizard_leaving_partner_mode_text': 'You are about to leave partner mode. You can not return to partner mode after you click confirm. Do you wish to proceed?',
    'wizard_loading': 'Loading Wizard...',
    'wizard_save_template': 'Save template',
    'wizard_skip_step': 'Skip this step',
    'wizard_step_errors': 'Step Errors',
    'wizard_submit_button_message': 'This submit button skips all subsequent steps, changes you have made in this step could affect other steps.',
    'wizard_user_template': 'Select a template from your local machine',

// General labels/phrases
    'activate_account': 'Activate account',
    'adc_access': 'ADC Access',
    'add_another': 'Add another',
    'add_cert': 'Add certificate',
    'add_cert_upper': 'Add Certificate',
    'add_service': 'Add service',
    'already_exists': ' already exists.',
    'already_in_use': ' already in use.',
    'at_least_one_required': 'At least one is required',
    'backups_used': 'Backups used',
    'cant_be_deleted': 'can\'t be deleted as they are in use.',
    'certificate_expired': 'Certificate expired.',
    'cidr_missing': 'Please use CIDR notation for the subnet. i.e 127.0.0.1/24',
    'client_connections': 'Client connections',
    'confirm_email': 'Confirm email',
    'confirm_delete': 'Confirm delete',
    'confirm_delete_message': 'Are you sure you wish to delete ',
    'connection_details': 'Connection details',
    'connection_method': 'Connection method',
    'connection_options': 'Connection options',
    'contact_number': 'Contact Number',
    'contact_sales': 'Contact sales',
    'contact_us': 'Contact us',
    'copy_output': 'Copy output',
    'create_account': 'Create account',
    'created_by': 'Created by',
    'database_name': 'Database name',
    'date_just_now': 'Just now',
    'date_time': 'Date & time',
    'date_time_sys_title': 'System date & time',
    'delete_backup': 'Delete Backup',
    'delete_backup_message': 'Are you sure you want to delete this backup?',
    'delete_group': 'Delete Group',
    'delete_ip': 'Delete IP',
    'delete_ips': 'Delete IPs',
    'delete_user': 'Delete user',
    'delete_users': 'Delete users',
    'domain_name': 'Domain name',
    'down_time': 'Down time',
    'download_csv': 'Download CSV',
    'downloading': 'Downloading',
    'external_weight': 'External Dynamic Weight',
    'feedback_agent': 'Feedback Agent',
    'feedback_agent_port': 'Feedback Agent Port',
    'feedback_method': 'Feedback method',
    'file_name': 'File name',
    'file_size': 'File size',
    'file_type': 'File type',
    'floating_ips': 'Floating IPs',
    'force_logout_message': 'Your settings have changed. You will need to logout in order for these changes to take effect.',
    'force_rollback': 'Force rollback',
    'force_unlock': 'Force unlock',
    'force_upload': 'Force upload',
    'force_upload_message': 'Do you still wish to proceed with upload?',
    'forgot_password': 'Forgot password?',
    'forwarding_mode': 'Forwarding Mode',
    'free_download': 'Free download',
    'go_back': 'Go back',
    'help_loadbalancer': 'Loadbalancer help',
    'help_portal': 'Portal help',
    'hidden_columns': 'Hidden columns',
    'host_name': 'Host name',
    'http_connection': 'HTTP connection',
    'ip_address': 'IP address',
    'items_per_page': 'Items per page',
    'knowledge_base': 'Knowledge Base',
    'last_alert': 'Last alert',
    'last_checked': 'Last checked',
    'layer_7_advanced': 'Layer 7 advanced',
    'licence_company_name': 'Company name',
    'licence_key': 'License key',
    'load_balancer': 'Load balancer',
    'log_level': 'Log level',
    'login_in': 'Login',
    'mac_address': 'MAC address',
    'max_conns': 'Maximum connections',
    'maximum_length': 'Maximum character length is ',
    'minimum_length': 'Minimum character length is ',
    'name_first': 'First name',
    'name_last': 'Last name',
    'network_address': 'Network address',
    'no_matches': 'No matches',
    'no_more_content': 'No more content',
    'none_set': 'None set',
    'nothing_configured': 'Nothing configured.',
    'password_confirm': 'Confirm password',
    'per_month': 'per month',
    'per_year': 'per year',
    'polaris lb': 'Polaris Lb',
    'polaris topology': 'Polaris Topology',
    'product_name': 'Product Name',
    'product_type': 'Product Type',
    'read_write': 'Read/Write',
    'real_servers': 'Real servers',
    'release_version': 'Release version',
    'restart_haproxy': 'Restart HaProxy',
    'save_file': 'Save file',
    'select_all': 'Select all',
    'service_outage': 'Service outage',
    'service_status': 'Service status',
    'skip_to_finish': 'Skip to finish',
    'software_updates': 'Software updates',
    'ssl_certificate': 'SSL certificate',
    'ssl_max_version': 'SSL max version',
    'ssl_min_version': 'SSL min version',
    'ssl_term': 'SSL termination',
    'start_free_trial': 'Start free trial',
    'submit_disabled': 'Submit is disabled as the form hasn\'t changed.',
    'subnet_add': 'Add subnet',
    'subnet_delete': 'Delete subnet',
    'subnet_delete_message': 'Are you sure you would like to delete subnet ',
    'subnet_edit': 'Edit subnet',
    'system_control': 'System control',
    'thank_you': 'Thank you',
    'timed_out': 'Timed out',
    'turn_off': 'Turn Off',
    'upgrade_options': 'Upgrade options',
    'username_email': 'Username/Email',
    'value_greater_than': 'Value must be greater than ',
    'value_less_than': 'Value must be less than ',
    'view_config_snmp_conf': 'SNMP configuration',
    'view_service_status': 'View service status',
    'welcome_to_endurance': 'Welcome to Endurance',
    'welcome_to_admin_panel': 'Welcome to Portal Admin',
    'welcome_to_portal': 'Welcome to Portal',
    'zero_downtime': 'Zero down time',

// Single words
    'account': 'Account',
    'accounts': 'Accounts',
    'acl': 'ACL',
    'acls': 'ACLs',
    'action': 'Action',
    'activate': 'Activate',
    'active': 'Active',
    'adc': 'ADC',
    'adcs': 'ADCs',
    'add': 'Add',
    'address': 'Address',
    'adopt': 'Adopt',
    'adopted': 'Adopted',
    'adoption': 'Adoption',
    'adopting': 'Adopting',
    'advanced': 'Advanced',
    'aes': 'AES',
    'ago': 'ago',
    'alerts': 'Alerts',
    'and': 'And',
    'apply': 'Apply',
    'arch': 'Arch',
    'attention': 'Attention',
    'authentication': 'Authentication',
    'available': 'available',
    'back': 'Back',
    'backend': 'Backend',
    'backends': 'Backends',
    'backup': 'Backup',
    'backups': 'Backups',
    'billing': 'Billing',
    'bond': 'Bond',
    'break': 'Break',
    'builtin': 'Builtin',
    'bytes': 'bytes',
    'ca': 'CA',
    'cancel': 'Cancel',
    'central': 'Central',
    'certificate': 'Certificate',
    'certificates': 'Certificates',
    'certs': 'Certs',
    'change': 'Change',
    'chat': 'chat',
    'cidr': 'CIDR',
    'cipher': 'Cipher',
    'cipher_usage': 'Cipher usage',
    'ciphers': 'Ciphers',
    'close': 'Close',
    'code': 'Code',
    'collectors': 'Collectors',
    'coming_soon': 'Coming Soon',
    'condition': 'Condition',
    'config': 'Config',
    'confirm': 'Confirm',
    'conn': 'Conn',
    'connect': 'Connect',
    'connection': 'Connection',
    'connections': 'Connections',
    'contact': 'Contact',
    'continue': 'Continue',
    'copy': 'Copy',
    'copyright': 'Copyright ©',
    'count': 'Count',
    'create': 'Create',
    'critical': 'Critical',
    'crl': 'CRL',
    'csr': 'CSR',
    'date': 'Date',
    'day': 'day',
    'days': 'days',
    'days_upper': 'Days',
    'debug': 'Debug',
    'default': 'Default',
    'dashboard': 'Dashboard',
    'database': 'Database',
    'delete': 'Delete',
    'des': 'DES',
    'description': 'Description',
    'details': 'Details',
    'direct': 'Direct',
    'disabled': 'Disabled',
    'disconnect': 'Disconnect',
    'documentation': 'Documentation',
    'domain': 'Domain',
    'done': 'Done',
    'down': 'Down',
    'downgrade': 'Downgrade',
    'download': 'Download',
    'downloads': 'Downloads',
    'drain': 'Drain',
    'duplicate': 'Duplicate',
    'edit': 'Edit',
    'email': 'Email',
    'enable': 'Enable',
    'enabled': 'Enabled',
    'endurance': 'Endurance',
    'enforce': 'Enforce',
    'enterprise': 'Enterprise',
    'error': 'Error',
    'execute': 'Execute',
    'existing': 'Existing',
    'expires': 'Expires',
    'external': 'External',
    'external_privacy': 'Privacy',
    'external_terms': 'Terms',
    'failure': 'Failure',
    'fall': 'Fall',
    'fallback': 'Fallback',
    'feedback': 'Feedback',
    'file': 'File',
    'finish': 'Finish',
    'fips': 'FIPs',
    'firewall': 'Firewall',
    'for': 'for',
    'forced': 'Forced',
    'format': 'Format',
    'forward': 'Forward',
    'forwarding': 'Forwarding',
    'from': 'From',
    'frontend': 'Frontend',
    'frontends': 'Frontends',
    'gateway': 'Gateway',
    'general': 'General',
    'gid': 'GID',
    'granularity': 'Granularity',
    'group': 'Group',
    'groups': 'Groups',
    'gslb': 'GSLB',
    'halt': 'Halt',
    'haproxy': 'HAProxy',
    'has': 'has',
    'headers': 'Headers',
    'health': 'Health',
    'healthcheck': 'Healthcheck',
    'high': 'High',
    'hostname': 'Hostname',
    'hour': 'hour',
    'hours': 'hours',
    'http': 'HTTP',
    'hypervisor': 'hypervisor',
    'hypervisors': 'hypervisors',
    'id': 'ID',
    'if': 'If',
    'import': 'Import',
    'in': 'in',
    'information': 'Information',
    'interface': 'Interface',
    'interfaces': 'Interfaces',
    'interval': 'Interval',
    'ip': 'IP',
    'ips': 'IPs',
    'ipv4': 'IPv4',
    'ipv6': 'IPv6',
    'is': 'Is',
    'issue': 'Issue',
    'json': 'JSON',
    'kb': 'kB',
    'keyboard': 'Keyboard',
    'keymap': 'Keymap',
    'l4': 'Layer 4',
    'l7': 'Layer 7',
    'label': 'Label',
    'licensing': 'Licensing',
    'lines': 'Lines',
    'list': 'List',
    'loading': 'Loading...',
    'local': 'local',
    'log': 'log',
    'logout': 'Logout',
    'logs': 'Logs',
    'low': 'Low',
    'maintenance': 'Maintenance',
    'manage': 'Manage',
    'mask': 'Mask',
    'max': 'Max:',
    'md5': 'MD5',
    'medium': 'Medium',
    'member': 'Member',
    'members': 'Members',
    'method': 'Method',
    'minute': 'minute',
    'minutes': 'minutes',
    'mode': 'Mode',
    'modes': 'Modes',
    'monitor': 'Monitor',
    'month': 'month',
    'months': 'months',
    'more': 'More',
    'ms': '(ms)',
    'n_a': 'n/a',
    'name': 'Name',
    'namespace': 'Namespace',
    'network': 'Network',
    'new': 'New',
    'news': 'News',
    'next': 'Next',
    'node': 'Node',
    'nodes': 'Nodes',
    'notes': 'Notes',
    'notification': 'Notification',
    'notifications': 'Notifications',
    'occurrence': 'Occurrence',
    'of': 'of',
    'off': 'off',
    'offline': 'Offline',
    'ok': 'Ok',
    'online': 'Online',
    'option': 'Option',
    'optional': 'optional',
    'options': 'Options',
    'or': 'Or',
    'order': 'order',
    'organization': 'Organization',
    'organizations': 'Organizations',
    'overview': 'Overview',
    'passive': 'Passive',
    'password': 'Password',
    'paths': 'paths',
    'pending': 'Pending',
    'percentage': '%',
    'permission': 'Permission',
    'persistence': 'Persistence',
    'place': 'place',
    'places': 'places',
    'platform': 'Platform',
    'pools': 'Pools',
    'port': 'Port',
    'portal': 'Portal',
    'ports': 'Ports',
    'primary': 'Primary',
    'priority': 'Priority',
    'product': 'Product',
    'products': 'Products',
    'prometheus': 'Prometheus',
    'protocol': 'Protocol',
    'provider': 'Provider',
    'proxy': 'Proxy',
    'purchase': 'Purchase',
    'range': 'Range',
    'rbac': 'RBAC',
    'read': 'Read',
    'ready': 'Ready',
    'recovery': 'Recovery',
    'references': 'References',
    'region': 'Region',
    'regions': 'Regions',
    'reload': 'Reload',
    'relogin': 'Relogin',
    'remove': 'Remove',
    'renew': 'Renew',
    'repeat': 'Repeat',
    'replace': 'replace',
    'reply': 'Reply',
    'reports': 'Reports',
    'reset': 'Reset',
    'resources': 'Resources',
    'restart': 'Restart',
    'restore': 'Restore',
    'rise': 'Rise',
    'role': 'Role',
    'roles': 'Roles',
    'routing': 'Routing',
    'rows': 'rows',
    'rules': 'rule(s)',
    'save': 'Save',
    'schedule': 'Schedule',
    'schedules': 'Schedules',
    'search': 'Search',
    'search_placeholder': 'Search...',
    'second': 'second',
    'secondary': 'Secondary',
    'seconds': 'seconds',
    'section': 'Section',
    'select': 'Select',
    'selected': 'Selected',
    'send': 'Send',
    'serial': 'Serial',
    'server': 'Server',
    'service': 'Service',
    'services': 'Services',
    'settings': 'Settings',
    'setup': 'Setup',
    'sha': 'SHA',
    'shutdown': 'Shutdown',
    'shuttle': 'Shuttle',
    'sidecar': 'Sidecar',
    'sips': 'SIPs',
    'size': 'Size',
    'size_b': 'Size (B)',
    'size_kb': 'Size (kB)',
    'size_mb': 'Size (MB)',
    'smtp': 'SMTP',
    'snmp': 'SNMP',
    'speed': 'Speed',
    'ssl': 'SSL',
    'start': 'Start',
    'state': 'State',
    'status': 'Status',
    'step': 'Step',
    'storage': 'Storage',
    'subject': 'Subject',
    'submit': 'Submit',
    'subnet': 'Subnet',
    'subnets': 'Subnets',
    'subscription': 'Subscription',
    'subscriptions': 'Subscriptions',
    'success': 'Success',
    'successful': 'successful',
    'system': 'System',
    'tcp': 'TCP',
    'teams': 'Teams',
    'templates': 'Templates',
    'tertiary': 'Tertiary',
    'theme': 'Theme',
    'then': 'Then',
    'tier': 'Tier',
    'tiers': 'Tiers',
    'time': 'Time',
    'to': 'to',
    'to_upper': 'To',
    'today': 'today',
    'token': 'token',
    'topologies': 'Topologies',
    'total': 'total',
    'ttl': 'TTL',
    'type': 'Type',
    'unlimited': 'Unlimited',
    'up': 'up',
    'update': 'Update',
    'updating': 'Updating',
    'upgrade': 'Upgrade',
    'upload': 'Upload',
    'usage': 'Usage',
    'user': 'User',
    'username': 'Username',
    'users': 'Users',
    'valid_to': 'Valid to',
    'value': 'Value',
    'vendor': 'Vendor',
    'verify': 'Verify',
    'version': 'Version',
    'via': 'Via',
    'view': 'View',
    'vlan': 'VLAN',
    'vlans': 'VLANs',
    'warning': 'Warning',
    'warp': 'Warp',
    'weight': 'Weight',
    'welcome': 'Welcome',
    'with': 'with',
    'year': 'year',
    'years': 'years',
    'zero': 'Zero',

    // Subscription page
    'adc_backups': 'ADC Backups',
    'online_updates': 'Online Updates',
    'asset_scheduling': 'Asset Scheduling',
    'dedicated_success_manager': 'Dedicated Success Manager',
    'professional_services': 'Professional_Services',
    'secure_direct_access': 'Secure Direct Access',
    'secure_warp_remote_access': 'Secure Warp Remote Access',
    'adc_security_insights': 'ADC Security Insights',
    'adc_certificate_insights': 'ADC Certificate Insights',
    'single_sign_on': 'Single Sign-On (G Suite + Azure AD)',
    'single_sign_on_tailored': 'Single Sign-On (G Suite + Azure AD + SAML)',
    '2fa': 'Two-Factor Authentication (SMS + APP)',
    'audit_log': 'Audit Log',
    'license_management': 'License management',
    'api_access': 'API Access',
    'asset_scheduling_pipelines': 'Asset Scheduling - Pipelines',
    'white_label': 'White Label',

    // TODO remove when RBAC complete
    'user_invite_new': 'Invite user',
    'user_permissions': 'User permissions',

    // Validation messages
    'base_64_not_found': 'Can\'t find BASE64',
    'domain_validation_error': 'Invalid domain name. Please ensure the following: ' +
        '<ul>\n' +
        '<li>The domain name contains only alphanumeric characters, hyphens, or dots <br>and begins and ends with an alphanumeric character.</li>\n' +
        '<li>The domain name does not exceed 253 characters in total length.</li>\n' +
        '<li>Each label (subpart of the domain name separated by dots) is between 1 and 63 characters long.</li>\n' +
        '<li>No spaces or special characters are allowed (except hyphens and dots)</li>\n' +
        '</ul>',
    'duplicate_adc_label': 'An ADC with this label already exists.',
    'duplicate_already_in_use': 'Duplicate. Already in use.',
    'duplicate_certificate_label': 'A certificate with this label already exists.',
    'duplicate_cipher_list': 'A cipher list with this label already exists',
    'duplicate_fip': 'Duplicate floating IP address',
    'duplicate_global_name': 'A global name with this label already exists',
    'duplicate_group_ip': 'This ip is already assigned to another group',
    'duplicate_group_name': 'Duplicate group name',
    'duplicate_header_name_type': 'A header with this name and type already exists.',
    'duplicate_hostname': 'This hostname already exists',
    'duplicate_member_prefix': 'A member with this ',
    'duplicate_name': 'This name is already in use.',
    'duplicate_namespace': 'This namespace already exists.',
    'duplicate_pool': 'A pool with this name already exists',
    'duplicate_port': 'Duplicate port.',
    'duplicate_role_name': 'Duplicate role name.',
    'duplicate_route': 'This route is already in use.',
    'duplicate_sip': 'Duplicate static IP address',
    'duplicate_subnet': 'Duplicate subnet',
    'duplicate_value': 'This is a duplicate value.',
    'email_in_use': 'A user with this email already exists.',
    'email_mismatch': 'Confirm email doesn\'t match email.',
    'file_extension_not_found': 'Can\'t find file extension',
    'headers_invalid_text': `The L7 Headers text areas should not contain invalid characters.<br>
        <ul>
        <li>Allowed</li>
        <ul>
        <li>application/json</li>
        <li>text/html; charset=utf-8</li>
        <li>Mon, 27 Jul 2009 12:28:53 GMT</li>
        <li>  spaced value  </li>
        <li>\\t control character</li>
        </ul>
        <li>Not Allowed</li>
        <ul>
        <li>∑ Unicode € characters</li>
        <li>\\u001F control characters</li>
        <li>\\n \\r control characters</li>
        </ul>
        </ul>`,
    'hostname_validation_error_message': 'Invalid host name. Please ensure the following:<br>\n' +
        '<ul>\n' +
        '<li>The hostname contains only alphanumeric characters and hyphens (-).</li>\n' +
        '<li>It must start and end with an alphanumeric character.</li>\n' +
        '<li>The total length of the hostname must not exceed 253 characters.</li>\n' +
        '<li>Hostnames cannot be entirely numeric and must include at least one alphabetic character.</li>\n' +
        '<li>No spaces, special characters, or underscores (_) are allowed.</li>\n' +
        '<li>Hostnames are case-insensitive.</li>\n' +
        '</ul>',
    'incorrect_password': 'Incorrect password',
    'invalid_card_number': 'Invalid card number',
    'invalid_certificate': 'Invalid certificate',
    'invalid_cidr': 'Invalid CIDR.',
    'invalid_email_address': 'Invalid email address',
    'invalid_email_address_length': 'Invalid email address, too long',
    'invalid_file_type': 'File upload must have extension of .pem or .pfx',
    'invalid_integer': 'Value not a valid number',
    'invalid_ip': 'Invalid IP address',
    'invalid_ip_cidr': 'Please use the correct notation for the IP/CIDR. i.e 127.0.0.1/24',
    'invalid_ip_domain': 'Invalid IP address or domain',
    'invalid_ipv4': 'Invalid IPv4 address',
    'invalid_ipv6': 'Invalid IPv6 address',
    'invalid_ip_long': `The IP Address is invalid. Please ensure it is a valid IPv4 or IPv6 formatted address.<br>
                An IPv4 address must:<br>
                <ul>
                <li>Contain 4 numbers separated by dots</li>
                 <li>Each number must be between 0 and 255</li>
                 <li>Cannot start with 0</li>
                 </ul>
                An IPv6 address must contain:<br>
                <ul>
                <li>8 groups of hexadecimal digits separated by colons</li>
                <li>Each hexadecimal digit must be between 0 and 65535</li>
                </ul>`,
    'invalid_ip_or_domain': 'Invalid domain or IP address.',
    'invalid_name_characters': 'Invalid characters. Should only contain a combination of: a-z A-Z 0-9_- {} [] () . , \' and space',
    'invalid_name_start_space': 'Names can\'t start with a space.',
    'invalid_name_length': 'Field length too long. Should be less than 253 characters.',
    'invalid_name_length_short': 'Field length too short. Should be more than 2 characters.',
    'invalid_passcode': 'Invalid passcode. Please try again',
    'invalid_password_simple': 'Invalid password. Password must be at least 8 characters long, ' +
        'contain 1 uppercase, 1 numeric, 1 lowercase and must not include any special characters e.g !&$£@',
    'invalid_password_complex': 'Invalid password. Password must be between 8 and 128 characters long, contain 1 uppercase, 1 numeric, 1 lowercase and one special character, special characters include !@#$%^&£?*-',
    'invalid_path_end': 'End of path must begin with a \'.\'',
    'invalid_path_start': 'Path should start with a forward slash: /',
    'invalid_phone_number': 'Invalid phone number. The + is optional but the first digit should be 1-9 and then up to 14 digits (0-9).',
    'invalid_port_range': 'Invalid Port. Port range must be between 1 and 65535',
    'invalid_redirect_location': 'Invalid redirect location',
    'invalid_san': 'Invalid SAN. Acceptable formats include IP Addresses, Email addresses, domain and sub-domain names',
    'invalid_start_time': 'The start time cannot be in the future',
    'invalid_time_unit': 'Not a valid unit of time, should be: us/ms/s/m/h/d',
    'l7_mode_reset_error': 'This field has been reset because the mode has changed and the previous value was not compatible the current mode.',
    'label_in_use': 'This label is already in use.',
    'multiport_invalid_format': 'Invalid port/s should be 0-9. Separators: , or -',
    'multiport_out_of_range': 'Invalid Port/s Not between 1 and 65535',
    'no_logs_before': 'There are no logs before ',
    'password_mismatch': 'Password does not match',
    'port_none_checked_error': 'At least one port option must be checked',
    'port_range_overlap': 'This range overlaps another.',
    'url_validation': 'Invalid url'
};
